import { useState, useRef, useEffect } from "react";

const NAVY = "#1A3B6F";
const NAVY_DK = "#0E253F";
const BLUE = "#0066aa";
const BLUE_LT = "#E6F0F7";
const GOLD = "#C9901A";
const GREEN = "#1E7B34";

const OPSC_LOGO = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAAoCAYAAAAbrx+3AAABCGlDQ1BJQ0MgUHJvZmlsZQAAeJxjYGA8wQAELAYMDLl5JUVB7k4KEZFRCuwPGBiBEAwSk4sLGHADoKpv1yBqL+viUYcLcKakFicD6Q9ArFIEtBxopAiQLZIOYWuA2EkQtg2IXV5SUAJkB4DYRSFBzkB2CpCtkY7ETkJiJxcUgdT3ANk2uTmlyQh3M/Ck5oUGA2kOIJZhKGYIYnBncAL5H6IkfxEDg8VXBgbmCQixpJkMDNtbGRgkbiHEVBYwMPC3MDBsO48QQ4RJQWJRIliIBYiZ0tIYGD4tZ2DgjWRgEL7AwMAVDQsIHG5TALvNnSEfCNMZchhSgSKeDHkMyQx6QJYRgwGDIYMZAKbWPz9HbOBQAAAimElEQVR42s2aeZhcZZX/P+d9771V1UuSztLZWcKmDYIQddQfMx0VNJCQBLFCSAIZGYkLKg6OI0KgUugwDK4z+jAuoxIiAl2ArAKytjAOKMjeEjbZA52lk/RSVffe9z2/P25V0gkJwvzmeX5zn6efrq6+973nfc/2Pd9zxMwvnUWufRXeFcAbEPZ0iYAqb+NSQBw2rFHf9hl/Q/kXFHsslcVup9tKJUO57KOjvnJA0j7+U4LMVZiFSCuqKrBJ4SHx6eX+ulVrAUexaKlU3OjnzcJvfFWjwuHENY9gRknekFocaBVkk4j/s0EfSX+16g9vWG8XuQDsgvM/4YPoZJT3AZMQMajWEHkJ/H/aOF6T3ljqbexbdrxzD+sdV5rvg/zJIH8FTEUkRDVBeAXlXhNXf+ZuKt/d3EDjMBFZdMErhPlpuFgzlez+MkZwqcdag387WlN15Fot1cFeve7sOW84mIYCzYLymRq2nEsQjcOn4N0O6xADNsg+u+S+YHDTZ5Lf/Msj29dqrCGL/vlOWjs+RDySPfOXjClNPCKPmvrWsrvxG9fubEwlA2XPh/9+uozt/AlB7hhEwKWgfocFiwVjwaUen6zV15/+Ar/72eAblNZU1kfPnCmtnRdjw/kYS7ZX3zRuMAZM0Fgv/qluXvdFei+pNxxJDaDbBXgzZdUSxrfncXGC2bNed3/5FFALQFeX7qosWfj1i7Rt0reBccRVh0sUrx5Vl/04JYk9Sd0R5N+ftk/8bXDM2e+hUnGUSmaUDoZJa440jklqjqTuGr9j0lqdpBaT1JLsu9iDGmzwbt866VfmuNV/R2Vx5mmlkoHVylFfmSZjJ/+WfPsxpHH2jDrdLpdXj0+UpOZQB4WxK6Rz/1uYv7KF4mJDM1w1lJWbd9YsaZv8n+Tb5uNST1Lz+FTRUXv16aj1Ok6TjgOvpXuOpVg0vAUzzJS1tcqR79qLx753KqccdShu6zDGyB7DpjUGa2RUcN3NvU3Pmn/eiRTGfYXaYIJ3iohFRbHWEBUsYd6CCKKCiCUeSbHhGJdvu5ojz+oAoP8JabzGZCaPRcQiWMRYokJE1JIjaokIcmG2XiNkJnVHGnuNWn8YHrPqXVQqnr6DBQRpGXMpubZZ1IbibD01IEKYt0QFSxAalExmMFS3xbSM+6DIjIsanr9Dad0r8nHQfg1hYSa1oQTBZGFVlCA0RC2WIMr2vn29rTEtHR+TMR86t7nemyrMiOBrCR96337ctKrItPHt/Pzzx3LyvNn4arJbpfnUkw5VSYfr+D0HWaFS9Bz95VYN8t/CxYpiERFUlSAypMlmaoM3Uh/pbYSeLIOKBCS1hPyYvWR8y9mUy57Og82ek66PqW29iuq2y6gPXUVafYwgNM2cgIjFO0+YC9KoUAaUymJnjz33WApjPkI8nCISZe/ObIf68L3Uhq4jqT9DmB+9VkhtKCHMfSqat+qAzGNLIeWyN+37fpmWsYcRjySIhA0BPWHOkNb+RG3wOpKRRwiiUesRUh92BPmvMO/s6VQWO/OXU5AShAG/f3o9B5z0HS6563E62vNo6nbyG2sErcUc9e59uPSrx3P0e/cjkkyBb3Cw7pIFUZNvK5Jvm5HlEgyKJ4ggrT+arw0cptetOk6vO3uOiYePA2qIVUARAuKqYsNP8ZGzJlApJruTHDEgDOp1556o161arteeXdRfnX0Y8ciFBDlBG7lAxJLUFDFzmVuaAeDD3CmjcpCCVaBm4uHj9Lpz/lqvO2eRPvXHg6U2tBobCaoJqh6RkLYJucRGK7MUQEr3GeM0zH2JpO4b3kNjr4ba0AW6+dZD9bpzFum157xb6oNnYkMBPIigXsm1FYzNLwUwfwnjIcLLmwZ5ZfMgz6x7lef7t/LSxkFkF+AhIpA69ukcy8lzDuE35ZN47N/+juM/cBCMxATW7rh5Dh5AbbQEHbVQllfF1ge/UL3lopcpliJW/ih0N5RvJKn+pGHNDkTwzhO1jjOF/LG7RWQ7NiHML42nuxSw8kchoHrdqrOJq88RRJmRgODVE+ULNmcPbQCdw/GpoGTvDHOGpH6du6F8I7N/FFLssfT1JP76VWXioWtoHR9mIc3/mcGN3wzi6lq6SwHlsjdjOhYStU7EJQoYVB1R3lAful2vX3UOvXc7uksBJTX++vO+SzxyI2HeNPKaoE5VgnkAwV8KiWoNT7+0kXWvbOK6i0/jqdcGuPfxF9HQIkbAa9OewVr6t45w9X89yaF7d3Lg9Am8Y8YENHkKiRpu1newUFnsOOqrY0Hei0tkh3eFhqT6fDoc/K6RqBOKPYZSydiH3FXOJV9AMQggogiqNvgosPbNw0Td0XthSq8K3a8G9JZT8P+JDWbhEg8YBMUEqJgZDQscj3oQFZAGIqQGwKSaoesJR/cTljklHzwQX+Bq26zURy51tadu5bZfDCfNPA2oCRdmprO9vABVjKv/m1MV5qy2mUwElEqYP7r/8Krzt+dllwgiXXzk9Al7VFgQGJKhOmFk+cbJ3Ryy9yQefb6fd8yYwAWnzOFrl9zFxk2DhGNaSJ3PHMUaNg9VWf6vN2FTz7z3H8Czr29B8iHOx4wGCEEUvcMF0Xi802aywVjA9NFbTunssYCnUvSwWNMFX3lGklwVGxYypCYG5wSx7x5d37zFS0C27BYMede2G41bkqoS5I4P5p370/SmM+7hFqBUgr6DJblp8YPAolEhP6AX38hhEYk5Apdk3iqqGGtJqiMuGXwgU6I6KGeRp1z27thzHpa4WsXaEPUO7w1GJga58fubN+ZpwRoh2TTEew6cyo3nLWb6hHaGagmnH/se8mGm46vOPoH5HzyIZPMQ0kCTAFaE8W0FhuspPbc/xoNPvgK5EN/wRA6aJgA+sPtjQ7IQ1/QYA/iXd0J+zUPd2r8ZkY2IIUNSKo1yYSa/G5rYqI/fRr3hJzRz+85hxTYsS/sRq6hoI5eAyBiXb79DFl3wg2huqYty2W+v24o9Ed2lABB6yymlbJXcYDoTkemoA0FQ0cwweZlbx76+0x7L5Uyg5IWNoJBrC7C5AGMNNhK1Znqwq7J8kuLjlC+fdCQLP3AgD//5dY5850wOnzUFgLlH7Mdzr2/hpgee4UuL/oq/OWRvvrbmLpI4zfYFOO8RKwT5At77nQvtgVcbENxO321V4f2m3aVSetfUWHTBth3PiKAKYsaE+cKkBPrRPWHSnKXYY+n4seHH5QZAMR/IiuBGiFWVrFhPNzQ8rRcbvBNXd1n5I4JLFTEh+bbTExOcJsdf+Gvj0kvd1qdvprI4C5fNYr6vTwBcYGYQhAFp2mBf1GdGp69D2e8SHbK9fnC/qvwx/gLVbV5cvEnEDohna5LwfLATaHCOvSa08+1PfYRcFLDulc188sOH0VaIGKknDFdjoihg1uRxfO6Y2fTc28fMSWO4+fwl/OPP7uDhp9Zn6zRymvN+J0yxkxbEjN/t2RqzTXdzdwYsZKRRJ+h2JGgDUQ3HvEnwU24sDzQ82dFVjOSAw84hKuxLEu+gsEQMSd0Frv5IDIT19PuJrZ6GWBr1oWSbU6U+4hETERUWedVFEnQ9JQv/6cd+yys/onLxEMUe24wQSjAx86hEt3uSCKAD23P6rle57D38dLe4YleQYZ2yeajGvpPG8qmj301LPsSrcvNDz/HOpd+ldPk9qCqqykl/czCHz5pMLrA4rxmtwlukrZTW3X/v3gjRS6sbXin10YaYFa0GTWnZodhRRZh6UGmXhd+4RhZ+oyIL/+kGOeiIJ4hazyONdbuyVB1BDnz6UHzjP6+jVAriW8p9Eg+vImoJQDImomkCIhZUiasZk2LDA7Uw5lsyYZ+H7LxVx1JZ7ChsbgAO2wqG7YBDpKm46s6h/w2lT0B3KaDYY3ewL0gwut6SMODPL27kiZc2svKjhxOnDkEIA8PWkTqbXujn1YHhrL5FSVLHQdMn8PT6LTz25CvQmn/r5PAea3bj3iTv7En5wR6KSBCJyLcv2M6fegfpKM9SVUQ8YqzR+OsOlLszhOcriy+UBee3k28/GwTSmqI0nhXZXlOliSeNPUG0v28Zf5OZf94Sf+P5VzZk3r1sYuI3PZ8MNb65h6GKRAGFKNied5pZ4T37TaH05YUs/5uuncgmr4o1gslHb4/KV7eHm3XPpcaecpTxyZtWk3EtJq7GxLWYNE4agqZAirFCvj2kuuX77vry9RSLGcSuLHaUSkavP+8cU93yEdLaHZhAyLVYTCBZjdSwoIxmCkhjh3rVqPXn0TFnHdgIW24PxmT/wgFJ45hlzwprGJxqFh6jwBLY7JZD9+5k9akfYcH7DshgvzWEgd1OBPu313cB1aE9eFj0xpi+urG4z29ntRvBCXUIjOzcRtm1RokiwuZPPiQqWKJCQFgIgC0yvOkcvf68L1IqGSoVPzqXUCxad0P5Tr3mrKNsbfCvqQ//FO/6M54zMtvZkiZj4lJH1FJIwrZVGfkkI1lo3gXBKnkAOg/ew8GJNmK/bieQUQl2Sw00lLDsu9ezccsIV591PN+78QHuvO8pJk8bz6VnzOfMS+5k3bOv8YuzTiAX2rfbKENUN+juo9iY3dRM2sgdLY33NOKbCM75VNmyx3JLvSOt9jV6YYpKHWEAeEGUP+S29d9avfO7r4AKZdkl5pYM/QjFUkQXaVou3wvcy/wzJxo3fr7a8LOE+feR1ndYkYghrSvGHEN3dyDevdyA9M0QLJnotGfU1RO7P7iFZ4xjy7gU7q7R25tmSLL85kzHTQ88y9bXtxCnC/jDM69x1+/WMXa/KXhVbnvkedb98TlGzlxAYOQtYw06pmUn7vVFzXpesoMhVhDt3O1zs1cWgLE7DEMbfSi3lcHBjU0r2En1xgrOb9XqE0dyy2Xbdke9Vbd3DkaFru5S0Cxi6R2VOItFC0WoLN7o4RLgErPwn7+qUXQhLvWNiGXwDoydSNucvdK09oykuRRjggwyizT6X1O2e/FOFobSVYyEyfcwMZyEmzvIoo8NEuSGTH34e2+qsCnjWkkThxGhNRdi2wqMa81lnjy2hZcmtGON4W351rpXNYMWyVM+rSsiOywv28/e2/nGXoCSQFmZPGkSKhN3KUCFNH6R3u9saoT93YtiZ9rsMEoCq5XiYkN/V2YlTUZi14TfCyz4yjRj2o9Ubz6sOlyi8s/90JPll+7Vljl4X/7av8iib3yMqO1DJDXXACKZbGG+g5vKz7Hogpcw0b6kSVbwqwORmcw7q4ObLhzYrqhSSSiXlf0OnI6xXRhrMGYyCAQ5NBn5SbC7MOK9x3nPLectxim05iOqcYpH8V6pJ54rzlzISC1m8tgWHnu+H8xbJBkaikhGXnpacge9QpCbsd06XQpIF+//+wJQB4RuDHNK2Ac5yEf5iCR2WZ8Lh7EC+tBbrCUUVme5oYLbY9U2e2Vgpk37oob5Y4H3aJAbQ9SK2frqf3lYQ3F1RKUc00tKZymi2OOor3sEE3xoB1eI4B2h1rIaRf392GCfjLeUAOc8QX6crVff7UqlXu7G0FtOWT/Ngnhj8kdqlDfE1QTEIgJpHAcu/cNusXU+CrDGsM/kcew3ZRxh0GhVuYy1GNMSMW18G/tPG08UWFpyEW+rB13ssfSuqaG+lyBUBI+INBL2FDt+zDGUy57ukqV3taNc9t6Gp2T9KHSUR4p4dyv/U1epJMyf6tRGn6Iw9sMgY0jqCfWhRIPcOcxe2UKlHGcIToVKOaay2GGC/4NPMtak2TdTtyXZMvhyFk3qVzXlHRWu8WH+jCzsllNKJcOPP52AomLOyKYAGtEnCAX1T8WFvqeDN5QtgeHhP/dz7X1PkTjX4BYNW4ZrjB3fRhRYrrinjyiwOO8JreWB517bI+J+01LM19d475aNymOCd+rzLd8L5pVeTm8q/56uvsjsv/o0DfNLSWo+6zCoYgNDPLLJb910yx6HXt7u1bB0OW71tzSN/yMbipGQNPaEhQNkr31uCqaVzkhukMcALRz1lWm1to7ziPLv3cGaSEoQWmr1/6L3Oxsp9lj30n/9WoLCC4T5vRpzJJa45olaFsqiC/5JB17/JuXyFrrPnCjjxl9A1DqbpNbonWmKDQPxQ5drpeKCnWk8jwaW4XrCTQ8+g9cdiPFde09k9n6T8V65/dHnR9WcwraROi2tOUa2Vd/avEejxnHl8h2y8Bv3k2//K+JqFv9dothwposK98miCx4FbdewZRY+2cFkKClhPqQ+8u/0/usW5s7KcQv1/2eF9ZYdqPjaP1whNjqPMD+TNM7kSuqesGVOinlIFl3wJyCuiexP1NJOUt2Ri0FRFeNr33UAg/cE3Pf9qiw4/3y14U9J4xTEZG2TWMm1ni3jp/wdiy54BZG9CQsTSOs+Gx/AY0NDbWiTHx7+SRPWa7Ok8c5z1BH78qFDZpI4z+ipDK+aKRAY25IblRiUwIxlbGuOtb95lMT5Pc3I7ewBGTnqbDzyeRfk7sMEgk93KE2MEOYOQ3VXZiIhKoRUB5/RTYMXUSoZ7t7s/oeColKsWCrfHjbzz/28j1quz4ha31BazSPGEOQORsgmqJqGliHAhEJ7xOCGn7kbvn5bRgR/v06xaH3lvJ/LwvOLtEyYS20wzsYOEOKqw4aTMXYy3rEduCgeIx4bBlLberreceEmikfYANSg6hRUjEjfyxt5/KWNexqd2WNnOrQGF1keePY1nFPESoP4FQcK6nfOl5WKo1i0aeWCB8y8Vadqy/g1mBy4OG20x4Q01lHkb4qqkGsNSaqvB8m245PffXOQo0tmR/GpDkgRXANiC0L6tlRWWewo9lhXWXyDmV/6sraO/zbegUuacmk2g9Jo42URJcXagLAlYmTgan328c82WPvMeis9ntJq0TvWLxUJf01hzPupD2mDkBa8S/FpcwJGsvWCgCA0MrTpXH/j+Vc2h5YClBpRq8VloOzVgfi/a5sQRqSqYAVpEi/qLVErxMO1N7DTjZlCX1l8qT3m3A2+pf07hPl3ZAXvLnOJxoJLIB75jQ4NnJ785sJntrcmGp1dkHEZWUuASDbfV9s2iSQn/x2l+cri79jjSs/7qO1CwvwBiGQzhNvnEs2OwbO01i8jm7/trzv3omyfO4Y/QZSyAjKghy4/SmYdfBHWnkZYCFG/Yy6xOecoQFJ/WYa3fM3fuPPwbWBc/FkfD/0DXnOZkyH/LYUJaJKMlrKJhpTqlkHrk9Xp7ir7HRZ9M90r7jId+x+vEn4U0XegjG0Mo/Qj+ohJ4+vd9aW7dp2izbrSIK767wxtug0Xe1BBrOBcVet/gbrao9KK1lXK1zB7/i1mxgePU2OPBv9OkHENr9+C8LQ491tff+16veX7Gxrf88ZSQxRUeFSG9VFODz+26mJX8IvU8AE8MzASoToC+qzAbX7Di1frvf8+kHnqYsf/uqtYtG/RlWWn4dH/NXLtmOH4i6b91u7b7XrS3V0KNnRiCh3r9cGBAT+7o8MAtK2bqkMHrReAtqlTlbuht7NPm/+fNXCUf4KKLXR0aNu6qdo7B0/fwTK743YDMHotmM2DU191JeDuu+82nZ2d2tXVpeVGS7yYTbXS39UlG/owhY5pOmvgdl+pVFypVDLlvoOliycswMH0uUo26i3N5yqVii+VSlLpI4gHNwvAM3sd4rsa3e1iF2lfowNcqVRccZQSms+WR1FEu/6/u7tkXylsts/sdYjvXveq9vaWXVPuJ+iy8eBmmV59dLsXdHZ2KkB/f78095qxUGVtvEtnr1wZbH0xZ8buVfdtU6dqZ1+f9vd3ydBB66U6MFUmdeE7+/q0Uqn4YrFodpX7f+sl/x/WlP/VB3LCCUsOz+XCr6Vp8uzrr6//pylTpq3O5fIT69WR34nIjCif2yuO6484p6+CvzcMc99M0/SFIDBXqZpPB4ENkqR+wxVXXPGrE088cR9j7AXe+21BYP/ROT09l8sfNDIy/HilcuW3Fi8+aVlbW8tHBweHH7aWZ5OEV41xm4wJPww6M59vmVmtjtygmm4ECpVK5bYTTjjx42Eof1bV6fl86yer1eranp7Lr126dGlHmvqSMXa8MXpGmqbvKhTazqhWhyp4yBVyv6vX/TRICs6ZkdbWwj/W6yP3XXnlld8sFpec1NpaOGFkpHZ5HPvHgoDDrrrqykp3d3fQ29ubnnjiiQvz+ZZTRkaqV4K7ViT8dhDYzmp16Mv5fP7oNE3vEZHJ2cyRvCMIwg/HcXqNiJkTRTas1+NXRERaWgr7jowM/xZ4StUEuVzweL2efCxN49tbW9u/G8fxn0T04SjKHRfHsYK+JiJ3Oec2Fwqtq+r16h+MMT91Tk/t6bniomJxyRcDa+USEf91ET7W2TnlAtADnYsvjFNvwtCc6lx6lve+XcQsAzMfuE9VJjmnX1JNIu/9Jd67FzKIYf4V5FZVpiWJ+ybo9DiO/wP8841m6IKRkdqtIvy193K6MemZQF5Vl4Kveu8uBj4tYtcB24DbrJXZqnxEVaaAWwu6BLjWOV1mrdnXOXe7cywwxi5R1R+DOVpFD6jV3JPW+v2d46+DgL1V0x+omtOKxRPzxvAhVX8R6BejSP6kqgaozJkzx0+ZMmUfkK84578lokepmveJeAP2xjDMX+S9TBIJjlX1vwKOBZmSJO4y0AOcSx5IEj4Lfg3Y71WryRdFzDdANgC9IrIeODYMcx/2Xu8Q4d1JogG4mvfaArwkIp8UCSaquh+qmpPS1H/eWruqWFzyEPiPGtBtl1122VWqwQ9EeIcqOWvDU0UkL2JUxJ7qvc9nA1GmY/PmjT+qVC4/V1XWWBseEgT2FBEZ05jjabv88ssuVnXfAWaCCfP5/BKw0xsevTUMwyNB24AnvDdJmkoddANI3lr7tyLabwwvq2q9wab0q8q7VPW+NWvWXNvTc8WS7F1aEZGciPmbBh596dJLf/6rnp4rPgf6ZC4X/ECVL4BM9V6fWrt27Y0i/oci8iXv9eY1a9bcosotwGxjeK2RY7yIHK6qD//iF2uu7em58vMisq/37t9++cu1a0Fz4DeK6AwR5qu6G0XkwXw+d5qI3uF9erOqe6JSqdwrIj6Xs6er6mOq+jA4F8d2CKQA2vLLX679yZVXXnH6Ndf0XK3qH1bVe4zhDvAHgH9p7dq116nqj42R96vqnaCfU9UkEGHK/PnzW8AdoSp1ER1wLrkwSZwEgRlWdReKSEFVDGg4duzYGcXikgNE/AnO+VuMsd+q1dqGGoebX7p06d5pyiwRr6p+2/DwyPfBPdVsdIiwUTX4FqQnWGumG8Ogqh9njOmvVtOzgW+pcqSq3tN4piCim4BZ3d0r8p2dtbMqlStXq+p76/Xa+WGYO1JEPysiz61YsSI/MlL/OxHdN019Gcy+4I4SkX27u7sDVXm/Kn80xhzamDk6FOR1733LqI776yKy79y5c3Pt7WNPAxVjzLuXLl3a75yOU9V1InqriPmJqn/ee/1tmsb3iJh/EZFPA61z587NqerrSZK+ICLjVf2LInY/kdoYEU1AckuWLJnmHEd7zwMiYkRMu6ofD2YzyMy5c+fmQI9QFQ96pwh7WRuebrzXn48ZM+520BXO+e+IyLbLLruszzmzSUTWX3bZZX1hGG5U9RtF9OIwjC4X4e+952FjTLdI8MNcbnBFo/K7WFWuEuFCVfNdYODFF5/7Y6VS2dA4j6EtWwZ7KpXL+sDcKsKnrZVvA5eCToki+VdVrYrQm8/n/7ZYXHIVcBiYtSKmts8+5k4RJmatSlsLgugHxpijVeVs4EmR4E5j6FLlORH3kohsaCj+d3vvve9dIB8Ad7KqpitWfPKuhoJ+FATBx5ctO/nXixcvPtZ7f78qL0+ePO1OEQ4ALYM9U8TeAv6nwGbv/Z3AFcBWEU4LgtwXvdeKc2FNVbZUq1UHDF9++WVnq2qnquRBPxgEuTWqcokx/CwIwl+J8DljXD+4WNUPAha4X9Xf0tk59U4R8xHw3wHaVP1FqjyXjQIsWzZ1wYIF7Q2oWmgCkuXLl28fRRv1/+mZR8LSpZ/tWL78M53z5i3taN530kknTVy0aNGE5jOlUTVTd3d3kNW82XfFYnHSkiVLpjU+j12+fPn2bvPy5Z/pXLZs2dSFCxeOa363dOnSWaMR06JFiyaceOKJM3c8s3xfgJUrV4YrV64Mm+/Lnv3krNF/n3LKKfs1P5988skTTjnllOkrV64Md12rKduyZctmNL5vzcqhbK2VK1eGJ5988l7Nfa1YsSIP0PgtzbmZBQsWtI+WtVg8ZXp3d3e+eebNdzfPv/m+Xc4+4vjjj++cO3dZc45CFixY0F4s7hB+yZIl05oPjN4wwFFHFcc2D3Tu3Lm5Zccvm9pUXrFYjHbUetlzixYtmrBgwYJpo79r3tMQeuz8+fMn7gplly9f3tpULCDz5s3r2HnzO+qTpUuX7t1ce8WKFflly1ZOXbZs2U5zIs29zZs3r6NxMNI0oKaxNdcdvfau+x+t0GKx2Nbc96mnnjqt+ffcuXPHFIsrpuxOVoDZs2eHo97VzPUyf/78luOPXza1eY7z5580cdmyZWPkhBOKZWNYDzzS1dV1f19fXykM831JUrvNuWBCGPIx771N07hHpBCJJJ+8+urK6uOOWzI5DN0pQRBsFPF/rtfrj+Wj/OdTn24WkYtV5WvGcKuqHpSmvB4EPKgqXwZ5+OCD33H1448/ucgYOpLE94UhLzrn2guFlk/VatWbr7766juKxaLt6urSvr6+TuA4EVFVfQL4vfeca4x9HNwtlUpluFQqSV9fn6jKkjCMXBwnG66++so7isUTP18otGwbGtr6e2vt0yDfBv13YK+Ojo67Bwa2nhWG0VMjI4O3G2PGGxPMEzHD4P5YqVQe/MQnFn9aRF+oVCq3fvzjH5+fpvapww/verpcLuuoYvYDxgQfThL30DXX9Pz6E59Y/OnW1kJ927bqQ0Ggf3KOM6Ioetk5N1yrDd8fRS1HBAF/StN0pjHmOefksIkTx902MDBwsjGhqKYPFAqFdSMj1a+J2D+ppjcDk1RlCfBn473+qVKp/BDsYevXr7fZhKes7+/v3xYENici7aq6rVAo1IxJjwzDcMrSpUtn5fOuZoy0q/qZaZpuvfbaazfVE3e/anBng4nY6j3vBzMrCBgCCsaYOAzNC+Vy2RvjB1V1RhhylLVWr7nmmier1ZHHDzlkY++OKbOyF5F3Ao/39PT8B9gjnnvuOWOgPU3d1kqlMgRouVz21tqJxhD196+/zRjfDJ1RGJr+1tbWDUDUgNcngm0bGBjw1loDsr6zs3ObiETGmLGgU4HXFiw4tV2EA7O8h1prc6q1uMmIVDImXrJ9pi9Yq2NLpZIR0Zy1uQ25nHkNsMZITtXv670O33DDDa+L6Hjn9ChjzKPGmNYggA0bNnQA8ZVX/vKnIyP2lSRJCsbYFOTVjo6OkTg2dRF5WkRbTBCYw4rFJad7r08MDAx4UMnlogmdnZ0dqpqAPHnVVT2XDA8Pq4G2KAp+liTu/YB1Th8C32tMOA2QICDy3ucag73Pikge2ApstdYqEKma6RkCwlkrPWCa4UKsteb++2e0jD4QY8w64IhicclnQB5pa2uzGB479NCuO0blR7N+/UGbvIfJk6cVwXQ2pgi8SNCRJMkUIBLR+8GsA92rUqk47zG5XDShcWCoco8xPAKMzeUG3wnmTjDPFYvFfZ2TwQkTOucVi8v3H0Wnqfe23dqwoCoz7777bqMqqSodzpmpLS0tqqrPpqnebAzTGueyEZhUqVS2qmqUptjNmzdvFpExixef9Llczr8zDMOqqoT5fG7C4ODg2HyeAvgxIDP+L7ElnwDx6SYrAAAAAElFTkSuQmCC";

const SYSTEM_PROMPT = `You are the OPSC Online Assistant — an AI-powered guidance tool for the Office of Public School Construction (OPSC), a division of the California Department of General Services (DGS). You help Local Educational Agencies (LEAs), architects, consultants, and OPSC staff navigate OPSC Online and understand School Facility Program (SFP) requirements.

TONE: Professional, clear, supportive. Use numbered steps for processes. Bold key terms and form numbers. Always note users should verify final decisions with OPSC staff.

ABOUT OPSC/SFP: The School Facility Program provides state funding for California K-12 school construction and modernization. The State Allocation Board (SAB) allocates funds. OPSC administers the program. Official site: https://www.dgs.ca.gov/opsc/

OPSC ONLINE NAVIGATION:
- Login via DGS/OPSC website with district-issued credentials
- Dashboard shows all applications, PTNs, statuses (Draft, Submitted, Under Review, Approved, Returned, Rejected), and notifications
- User roles: District Administrator (full access), Authorized Representative (can submit), Standard User (drafts only), Licensed Design Professional (design sections)
- User Management: top nav → add/deactivate users, assign roles

ELIGIBILITY FORMS:
SAB 50-01 (Enrollment Certification Projection): Certifies pupil enrollment for New Construction eligibility. Steps: Dashboard → Create New Application → SAB 50-01 → enter district info, grade config, current and projected enrollment → certify → review → upload docs → submit. Can be superseded if projections change. Must be approved before SAB 50-02.

SAB 50-02 (School Building Capacity): Establishes existing school capacity. Steps: link to approved SAB 50-01 → enter each building (name, year built, sq footage, classrooms) → system calculates capacity → certify → submit.

SAB 50-03 (Eligibility Determination): Core eligibility form for Modernization AND New Construction. Modernization: buildings must be 25+ years old. Steps: Dashboard → Create New Application → SAB 50-03 → select Establishment or Adjustment → enter site info (name, address, APN) → enter each building (year built, sq ft) → system flags eligible buildings → complete eligibility section → certify → review → upload docs → submit. New Construction version requires approved SAB 50-01 and 50-02 first.

FUNDING APPLICATION — SAB 50-04:
Used for Modernization Full Grant, Modernization Adjusted Full Grant, New Construction Full Grant, New Construction Adjusted Full Grant, Advance Site, Advance Design, Advance Site & Design, Facility Hardship, and Seismic Mitigation.

Common SAB 50-04 sections: Site Information (name, address, APN, acreage, ownership) | Project Type (type of work) | Additional Grant Request | Excessive Cost Hardship | Adjust Eligibility/Joint-Use | Project Progress (milestones, substantial progress dates) | Licensed Architect (name, license number, certifications) | Licensed Design Consultant | Certification (Authorized Representative) | Review | Submit and Upload Documents.

Modernization SAB 50-04 Full Grant steps:
1. Confirm SAB 50-03 eligibility is approved.
2. Dashboard → Create New Application → SAB 50-04 → Modernization Full Grant.
3. Site Information: select site from approved eligibility list.
4. Project Type: select work type (renovation, HVAC, electrical, ADA, roofing, etc.).
5. Additional Grant Request if needed.
6. Excessive Cost Hardship if applicable.
7. Adjust Eligibility/Joint-Use if applicable.
8. Project Progress: enter design milestones and substantial progress dates.
9. Licensed Architect: enter architect name, license number, certifications.
10. Licensed Design Consultant if applicable.
11. Certification: Authorized Representative certifies.
12. Review all sections.
13. Submit and Upload Documents: attach checklist items (plans, cost estimates, etc.).

New Construction SAB 50-04 additionally requires: approved NC eligibility (SAB 50-01+50-02+50-03), Alternative Developer Fee/Adjust Eligibility section, Joint Use/CTE section.

Advance Funding types: Advance Site (land acquisition), Advance Site District Owned, Advance Site Environmental Hardship, Advance Design, Advance Site & Design, Advance Funding for Evaluation and Response Action.

REVISING AN APPLICATION: 1. Find application on Dashboard. 2. Click "Create New Draft". 3. Revise and resubmit. Original submitted version is preserved. For SAB 50-09 use "Create Duplicate Draft". To update nickname: Application Dashboard → pencil icon.

SAB 50-09 (Charter School Facilities Program — New Construction or Rehabilitation):
Steps: Dashboard → Create New Application → SAB 50-09 → select type → Application Details → Preference Points → Funding Matrix Criteria → Project Capacity → Site Information → Project Costs → CSFA Lease (if applicable) → Project Progress → Certification → Review → Submit and Upload. After approval: create linked SAB 50-04 from Application Dashboard; link PTN.

SAB 70-01 (Pre-K/TK/Full-Day Kindergarten):
Additional sections: Enrollment Data, CALPADS, Preference Points, DataQuest. After approval: create linked SAB 70-02 (Grant Agreement: Parts I-IV — Site Acquisition, Construction/Retrofit, Delivery Method, Signed Agreement) and SAB 70-03.

FACILITY HARDSHIP & SEISMIC MITIGATION: Applications use SAB 50-04 with Hardship or Seismic type. Additional documentation required: hardship findings, inspection reports, seismic evaluation.

ENROLLMENT PROJECTION CALCULATOR: Dashboard → Tools → Enrollment Projection Calculator. Enter historical enrollment data (3-5 years) by grade. Tool generates projections. Save output directly to link with SAB 50-01.

PROJECT TRACKING NUMBER (PTN): Unique identifier per project. Found in Application Dashboard → Application Details. Required for linking SAB 50-09 to SAB 50-04.

DOCUMENT UPLOADS: Supported formats: PDF (preferred), JPEG, PNG. Max ~10MB per file. Label each document from dropdown. Required checklists vary by form type.

APPLICATION STATUSES: Draft (in progress), Submitted (sent to OPSC), Under Review, Approved, Returned (needs revision), Rejected.

SFP GLOSSARY: LEA=Local Educational Agency | SFP=School Facility Program | SAB=State Allocation Board | OPSC=Office of Public School Construction | PTN=Project Tracking Number | PIW=Project Information Worksheet | Full Grant=50% state/50% district match | Adjusted Full Grant=modified grant based on eligibility adjustments | Apportionment=formal allocation of state funds | Modernization=renovation of buildings 25+ years old | Substantial Progress=construction must be underway by deadline | CSFP=Charter School Facilities Program | ADA=Americans with Disabilities Act or Average Daily Attendance | CTE=Career Technical Education | Joint-Use=facilities shared with public agency | Advance Site=early land acquisition funding | Hardship=special funding for qualifying facility conditions | Seismic Mitigation=earthquake safety program | CALPADS=California Longitudinal Pupil Achievement Data System | CSFA=California School Finance Authority | APN=Assessor's Parcel Number | ECH=Excessive Cost Hardship.

LANGUAGE: Respond in Spanish if user writes Spanish. Respond in Chinese if user writes Chinese. Default to English.

---

## ADDITIONAL DATASET — PHASE 1 DOCUMENTS

### FACILITY HARDSHIP PROGRAM (from Facility Hardship Brochure)

**Two types of Facility Hardship projects:**
- **Replacement**: Cost to mitigate the health and safety threat is GREATER than 50% of the Current Replacement Cost → treated as a New Construction project (50/50 State/district funding, or up to 100% for Financial Hardship districts).
- **Rehabilitation**: Cost to mitigate is 50% or LESS of the Current Replacement Cost → treated as a Modernization project (60/40 funding). A rehabilitation project receives 60% of eligible verified costs.

**Does my project qualify?** District must demonstrate: (1) unmet and ongoing need for pupil housing, AND (2) condition poses a clear and imminent health and safety threat. Qualifying factors include: structural deficiencies, environmental health hazards, traffic safety, close proximity to a major freeway, electrical facility, dam, industrial facility, airport, adverse air quality emission, pipeline, high power transmission line, or other health/safety threat.

**When to contact OPSC:** Contact OPSC early. Early involvement with DSA, State Dept of Health Services, and other jurisdictional agencies is required to corroborate the health/safety threat.

**Documents required for a complete Facility Hardship application:**
1. Facility Hardship Request Checklist (optional)
2. Industry Specialist Report (identifies and substantiates health/safety threat and minimum mitigation work)
3. Governmental Concurrence (written concurrence from a governmental agency with the industry specialist report)
4. Mitigation Measures (letter/narrative describing corrective plan and alternatives)
5. Detailed Cost Estimate (unit cost breakdown of minimum work necessary)
6. Cost/Benefit Analysis (comparison of mitigation cost to Current Replacement Cost per SFP Regulation Section 1859.82)
7. Site Diagram (with building ages and square footage, identifying all classrooms)
8. Photos of affected area (recommended)
9. Application for Funding (Form SAB 50-04)
10. DSA Plan Approval Letter (or letter stating approval not required)
11. CDE Site/Plan Approval letter
12. CTE Advisory Committee Letter

**Seismic Mitigation Program (SMP):** A subset of the Facility Hardship Program. Provides for seismic repair, reconstruction, or replacement of the most vulnerable school facilities. Funding is 50/50 State/district basis. No additional interim housing allowance is provided, but interim housing costs are eligible expenditures. Visit: www.dgs.ca.gov/opsc/Programs/SeismicMitigationProgram

**Conceptual Approval:** A district may request SAB conceptual (preliminary) approval before having DSA approved plans. After conceptual approval, the district has 18 months (or 24 months if site acquisition is involved) to submit a full funding application. Conceptual applications exclude DSA plans, CDE approval letter, and CTE letter.

**Frequently Asked Questions:**
- Q: Does Facility Hardship approval mean 100% funded? A: No. Standard funding ratios apply (50/50 for replacement, 60/40 for rehabilitation) unless the district qualifies as a Financial Hardship district (up to 100%).
- Q: How long does the Facility Hardship process take? A: Typically 90–120 days from OPSC receipt of application to SAB meeting, depending on workload and documentation.
- Q: Can a building be demolished before approval? A: The district may proceed at its own risk, but must have had essential site visits from OPSC and DSA. There is no guarantee of approval or funding.
- Q: Do insurance or site sale proceeds affect the grant? A: Yes. For standard replacement projects, 50% of collectable insurance/sale proceeds reduces the Facility Hardship grant.

---

### SAB 50-04 SUBMITTAL CHECKLIST (Documents Required for OPSC Programs)

**Documents Required for ALL Full-Funding Application Types** (New Construction, Charter, Modernization, Facility Hardship, Seismic Mitigation):
- CDE Letter: Final Plan Approval (not required for advance funding for site and/or design)
- Cost Estimate (not required for advance funding for site and/or design)
- CTE Letter: High Schools or Unified Districts (not required for advance funding)
- DSA Approval Letter (not required for advance funding)

**Documents Required for Design Applications only:**
- Complete Application for Funding (Form SAB 50-04) — the only document needed at Design Phase

**Documents Required for Site Only / Site Acquisition:**
- Appraisal of Property to be Acquired (NC, Charter, Facility Hardship, Seismic Mitigation)
- CDE Final Site Approval (NC, Charter, Facility Hardship, Seismic Mitigation)
- Escrow Closing Statement or Court Order (NC, Charter, Facility Hardship, Seismic Mitigation)
- Cost Benefit Analysis per SFP Reg. 1859.74.6 (New Construction only, if District-Owned Site)
- CDE Contingent Site Approval (New Construction — Site Only Advance Funding)
- Preliminary Appraisal of Property (New Construction — Site Only Advance Funding, must be dated within 6 months)

**Documents Required when there is a Health and Safety Risk (Seismic Mitigation — 4 Phases):**
- Phase 1: Eligibility Evaluation Report + DSA Concurrence
- Phase 2: Replacement Option Analysis + DSA Concurrence
- Phase 3: Rehabilitation Option Pre-Application and Evaluation and Design Criteria Report + DSA Concurrence
- Phase 4: DSA Project Application Approval Letter (required for all SMP applications except advance funding)
- Report from Industry Specialist (Facility Hardship & Seismic Mitigation)
- Governmental Concurrence of Industry Specialist Report
- Cost Benefit Analysis
- Site Map of Entire School (with grade level, type/function, square footage of all buildings)

**Documents Required for Conditional Requests:**
- Approval Letter from DTSC (only if using DTSC cleanup)
- DTSC Fee Invoices (only if hazardous waste removal was necessary)
- Special District/Utility Connection Fees (only if requesting off-site utility costs in Section 5(f))
- Geotechnical (Soil) Report (if applicable)
- Invoices for DTSC (only if required by DTSC)
- Local Authority Approval of Off-Site Plans (only if requesting off-site development costs)
- Offsite Plans (only if requesting off-site development costs)
- Narrative Document for District signature in lieu of architect (only if original architect not available)
- Relocation Cost Documents (only if requesting relocation costs in Section 5(d)(3))
- Site Development Worksheet (only if requesting site development grants in Section 5(f))
- General Site (New Construction/Charter, only if selecting General Site in Section 5(f))
- Site diagram/fire drill map showing classroom ages (Modernization — only if requesting 50+ year building funding)
- Site Development Worksheet for 50-year-old Buildings (Modernization — only if requesting utilities funding)
- Cost Estimate for Accessibility/Fire Code (Modernization — if requested in Section 7)
- DSA Approved Accessibility/Fire Code Checklist (Modernization — only if requesting 60% of costs for Access/Fire Code)

---

### SAB 50-05 FUND RELEASE AUTHORIZATION CHECKLIST

**Overview:** The Form SAB 50-05 Fund Release Authorization must be submitted within **90 days of apportionment**. Failure to submit results in a non-participation occurrence in the Priority in Funding Process. The 90-day window for CTE Reservation of Funds applications begins upon receipt of DSA and CDE plan approval letters (12 months from apportionment date to provide those letters).

**For New Construction Apportionments** (including Facility Hardship Replacement and Seismic Mitigation Replacement):
- Current Form SAB 50-05 with Header, Parts V, VIII, X, and XI completed, signed by Authorized District Representative
- District certifies matching share deposited or will be expended before Notice of Completion
- District certifies binding contract(s) for at least 50% of construction included in state-funded plans
- CTE advisory committee written confirmation (if not already submitted with SAB 50-04)
- Grant Agreement signed by Authorized District Representative (if not already submitted)
- Construction contract pages (first page, signature pages, amount, date, site, scope)
- Notice(s) to Proceed
- Accepted bid documents (including additive/deductive alternates if applicable)
- Labor Compliance Program (LCP) documents (if construction contract awarded prior to January 1, 2012)
- If applicable: prorate and explanation for multiple state-funded applications
- **Project Information Worksheet (PIW)** must be completed prior to SAB 50-05 submittal (online: dgsapps.dgs.ca.gov/opsc/piw/)

**For New Construction – Site Acquisition Only Apportionments:**
- Form SAB 50-05 with Header, Parts VI, VIII, and XI completed
- Certifies district has entered escrow for the site
- Escrow instructions for the site acquisition
- Grant Agreement and PIW

**For Modernization Apportionments** (including Facility Hardship Rehabilitation):
- Form SAB 50-05 with Header, Parts V, VIII, X, and XI completed
- Same matching share, binding contract (50%), CTE letter, Grant Agreement, construction contract pages, and Notice to Proceed requirements as New Construction
- LCP documents if applicable
- Prorate if applicable

**For Career Technical Education Facilities Program Apportionments:**
- Form SAB 50-05 with Header, Parts VIII, IX, X, and XI completed
- Matching share certification, loan agreement (if applicable), Grant Agreement

**For Charter School New Construction Apportionments:**
- Form SAB 50-05 with Header, Parts V, VIII, X, and XI completed
- Same requirements as New Construction plus: Charter School Agreements (if not previously submitted or since revised)
- PIW required

**For Charter School Rehabilitation Apportionments:**
- Form SAB 50-05 with Header, Parts V, VIII, X, and XI completed
- Charter School Agreements
- Same construction documents as Modernization

**For Preliminary Charter School Apportionments – Design Only:**
- Form SAB 50-05 with Header, Parts II(A), VIII, X, and XI completed
- Charter School certifies current financial soundness from CSFA
- Charter School certifies Charter School Agreements per Section 1859.164.2
- Grant Agreement and Charter School Agreements

**For Preliminary Charter School Apportionments – Separate Site:**
- Form SAB 50-05 with Header, Parts II(B), VIII, X, and XI completed
- Certifies funds needed to secure site acquisition
- CSFA financial soundness, Charter School Agreements
- If Charter School approved to hold title: appraisal (may be preliminary) and CDE Contingent Site Approval letter

---

### MODERNIZATION FUNDING CHECKLIST (SAB 50-04 Application Requirements)

**Required Documents for a Modernization Application for Funding (Form SAB 50-04):**
1. **Project Tracking Number (PTN)** — required for all projects. Generated at: dgsapps.dgs.ca.gov/opsc/PT/PTn/Default.aspx
2. **CDE Final Plan Approval Letter** — CDE must approve modernization plans. Not required for advance funding.
3. **DSA Approval Letter** — All modernization plans/specs must have current, valid DSA approval at time of submission. Not required for advance funding.
4. **CTE Advisory Committee (CTEAC) Letter** — All modernization projects must comply with vocational/CTE facilities requirements per EC 17070.955. Not required for advance funding.
5. **Cost Estimate** — Complete, detailed construction cost estimate signed by architect or design professional.
6. **Conditional Requests** (as applicable):
   - Site Diagram/Fire Drill map showing ages of classrooms (only if requesting 50+ year building funding)
   - Site Development Worksheet for 50-year-old Buildings (only if requesting utilities funding for 50+ year buildings)
   - Cost Estimate for Accessibility/Fire Code (only if requesting 60% of minimum work for these grants)
   - DSA Approved Accessibility/Fire Code Checklist (only if requesting 60% of costs for Access/Fire Code grants)
7. **School Board Resolution – ARBBA** — All current funding applications are placed on the Applications Received Beyond Bond Authority (ARBBA) list and must include a school board resolution with required acknowledgements per Regulation Section 1859.95.1.

**Submission methods:** OPSC Online (preferred), PDF email to OPSCApplicationReviewTeam@dgs.ca.gov, or hard copy. Electronic signatures are acceptable.

---

### MODERNIZATION ELIGIBILITY CHECKLIST (Establishing or Updating SAB 50-03)

**Required Documents to ESTABLISH Modernization Eligibility:**
1. **Eligibility Determination (Form SAB 50-03)** — Complete Parts I and III only. Fill in both Option A and Option B in Part III so OPSC can evaluate which yields higher eligibility.
2. **Site Diagram** including all of the following:
   - Total number of permanent classrooms (including classrooms used for non-classroom purposes like storage, admin, conference, libraries; classrooms under contract; science labs, shops, computer classrooms; undersized RSP/Pull-Out rooms; pre-school and community school classrooms)
   - Total number of portable classrooms
   - Original DSA plan approval date for each building (or year constructed if DSA date unknown). Per SFP Reg. 1859.60, building age begins 12 months after DSA plan approval.
   - If buildings received State modernization funding under the Lease Purchase Program (pre-1999), include the construction phase apportionment date
   - Grade level of each classroom (K-6, 7-8, 9-12, non-severe, or severe)
   - Square footage of each facility (optional but may yield higher eligibility than classroom count alone)

**Required Documents to UPDATE Modernization Eligibility:**
- Form SAB 50-03 (Parts I and III only, both Option A and B)
- **For enrollment data updates only:** only Form SAB 50-03 is required
- **For facilities updates** (additional buildings reaching 25 years for permanent or 20 years for portables):
  - Copy of original site diagram showing original DSA plan approval dates, identifying which buildings have newly come of age

**Key rule:** Districts may update enrollment data when enrollment has increased; if CBEDS remains the same or decreased, the district may keep the previously reported CBEDS. Districts are not required to update enrollment just because additional facilities have come of age.

---

### ARCHITECT SUBMITTAL GUIDELINES (Key Requirements)

**Plan Verification Team reviews:** SAB 50-04, full size DSA/CDE approved plans, off-site plans, cost estimates for site development/off-site/utilities per CCR 1859.76, geotechnical soils report, earthwork calculations.

**New Construction Plan Requirements:**
- Title sheet must include: Vicinity Map, Index to Plans, North Arrow and Scale, Legend
- Civil: existing conditions, demolition, grading, storm drainage, erosion control, fire code requirements, off-site development plans
- Architectural: dimensions, labeling, accessibility details, identify Special Day Classrooms, CTE, and ORG facilities
- Structural: retaining walls/ramp structures for grade changes >6 feet at 2:1 slope
- Plumbing: utility service installation plans from POC to meter or first building lateral
- Electrical: service installation from POC to main switchboard

**New Construction Cost Estimate — Required categories:**
1. Service-site and development costs
2. Off-site costs
3. Utility services costs
- Eligible Service Site items (CCR 1859.76(a)): Site clearance, demolition, rerouting utility lines, rough grading, soil compaction, storm drains, erosion control, stairs/ramps/retaining walls, relocation of portables in building footprint, fire code requirements, multi-level parking (if site <50% of CDE recommended size), removal/relocation of classrooms
- Eligible Off-Site items (CCR 1859.76(b)): Curbs/gutters/paving, sidewalks, street lighting/landscaping/signage, special district/utility connection fees, storm drain costs, safety paths (up to $50,000)
- Eligible Utility items (CCR 1859.76(c)): Water, sewer, gas, electrical, communications — all from utility POC to school

**Ineligible utility costs:** oversized installations, non-shortest connection routes, water/gas beyond meter, sewer beyond first building lateral, electrical beyond main switchboard, telephone beyond main distribution center, data/fire alarm/satellite/intercom/security communications.

**Modernization Cost Estimate Requirements:**
- Full project cost estimate broken down by Trade or CSI Master Format
- Indirect costs (general requirements, overhead/profit, fees) listed separately
- For 50+ year old buildings requesting utility upgrade grants: separate detailed utility cost estimate per utility type (water, sewer, gas, electrical, communication) — eligible up to lesser of 60% of verified eligible utility upgrade costs OR 20% of the funding authorized by Section 1859.78.6

**Facility Hardship Documentation:**
- All as-built or new plans for rehabilitation/mitigation work
- Detailed cost estimate with quantities and unit costs (costs consistent with Current Construction Costs Remodeling Repair by Sierra West Group)
- Lump sums not accepted
- Indirect costs listed separately: overhead/profit, contingencies, soft costs (design fees, permit fees, testing, inspection)
- Cost Benefit Analysis: compare mitigation cost to current replacement cost. If >50% of replacement cost → eligible for abandonment and replacement (receives 50% of eligible verified costs). If ≤50% → eligible for rehabilitation (receives 60% of eligible verified costs)

**Career Technical Education Facilities Program (CTEFP):**
- Purpose: fund construction/modernization/equipment for CTE facilities at qualifying LEAs
- 50-50 program (applicant must match state grant)
- New Construction: maximum grant $3 million per project per site
- Modernization: maximum grant $1.5 million per project per site
- Eligibility: Comprehensive High Schools per Ed Code 51224, 51225.3, 51228 or JPA operating CTE programs as of May 20, 2006
- Must have active CTE advisory committee and scored at least 105 points with CDE
- Documents for Full Funding: SAB 50-10, CDE score letter, CDE grant application copy, CDE plan approval letter, DSA approved plans/specs, detailed construction and site development cost estimates, itemized equipment list, CTEFP Funding Availability Worksheet (if requesting loan), 5-Year Facilities Master Plan
- Documents for Reservation of Funds: same except no DSA/CDE plan approvals required yet

**Cost Reduction Guidelines (SAB Publication):**
- Published by SAB to help districts reduce school construction costs while maintaining quality
- Key strategies: joint-use opportunities, careful site selection, simple design, standard building elements, factory-built components, proper consultant selection, pre-qualification of contractors, effective change order management, prototype designs
- Districts retain savings from construction projects under SB50 (1998)

---

### PLAN VERIFICATION CONTACT INFORMATION
- Supervisor: Jennifer Maestretti, 279-946-8450, jennifer.maestretti@dgs.ca.gov
- Plan Reviewer: Nicolaus Hom, 916-376-1613, nicolaus.hom@dgs.ca.gov
- Plan Reviewer: Ryan Yee, 279-946-8474, ryan.yee@dgs.ca.gov
- Facility Hardship: Lindsey Walden, 249-946-8458, lindsey.walden@dgs.ca.gov
- Facility Hardship: Hannah Konnof, 916-375-4037, hannah.konnof@dgs.ca.gov

---

### PROJECT INFORMATION WORKSHEET (PIW) USER GUIDE

**What is the PIW?**
The Project Information Worksheet (PIW) collects data required to:
- Analyze the relationship between the per-unhoused-pupil grant eligibility and the per-pupil cost of new school construction for grades K-12 pursuant to Education Code Section 17072.11
- Meet bond accountability requirements
- Track the status of the bid climate for California school construction

**When is the PIW required?**
- Submit with the **Fund Release Authorization (Form SAB 50-05)** for all new construction and modernization with High Performance Incentive (HPI) grant projects completing Part V of the SAB 50-05
- Submit with the **first and final Expenditure Report (Form SAB 50-06)** for all new construction and modernization with HPI grant projects that have received a fund release pursuant to Part V of the SAB 50-05
- Upload accepted bid documents including additive/deductive alternates with the PIW

**Who can complete a PIW?**
Superintendents, District Representatives, Delegates/Consultants, and Charter School Representatives — all must be logged into OPSC Online.

**PIW limits per application:** Maximum 3 PIWs per application:
1. Fund Release Authorization (SAB 50-05) submittal
2. First Expenditure Report (SAB 50-06) submittal
3. Final Expenditure Report (SAB 50-06) submittal

If a PIW has been created for all three phases, no additional PIWs can be created.

---

**Step-by-Step: How to Create a PIW in OPSC Online**

1. **Login** to OPSC Online at: https://opsconline.apps.dgs.ca.gov/
   - If you do not have an account, contact OPSCOnlineSupport@dgs.ca.gov

2. **Find the application:** On the Dashboard, type the application number into the Search box and click "Search All". Click on any phase of the application to open its page.
   - **Important:** The application must have a "SAB Approved" phase status before you can create a PIW. If no SAB Approved phase exists, you cannot create a PIW.

3. **Create a new PIW:** On the application page, look for the **"Create Linked PIW"** link on the left side under the Project Information Worksheet (PIW) section. Click it.

4. **Configure the PIW:**
   - Scroll up to see prerequisite fields
   - Select the correct PIW version from the dropdown:
     - Fund Release Authorization (Form SAB 50-05)
     - First Expenditure Report (Form SAB 50-06)
     - Final Expenditure Report (Form SAB 50-06)
   - Enter a nickname for the PIW
   - Click the **"Create Linked App"** button

5. **Complete the wizard:** You will be taken to the Information and Instruction page. Click "Start Application" to begin. Complete all wizard pages:
   - **Project Funding**: Project percent complete, Financial Hardship status, funds available (state apportionment, project funds, joint use, district match, additional local funds)
   - **Project Cost**: Construction cost details
   - **Component Type (Pages 1, 2, 3)**: Breakdown of project components
   - **Additional Information**
   - **Review**: Any missing mandatory fields are highlighted in red — click "Edit Page" to fix them
   - **Submit**: Upload accepted bid documents (including additive/deductive alternates), then click **"Submit Project Information Worksheet"**
   - **Important:** Click "Continue" at the bottom of each page to save your progress before moving to the next page.

6. **After submission:** Click "Return to Application Management Page" to see the created PIW. The PIW will show as "Submitted."
   - **Submitted PIWs cannot be edited directly.**

---

**Step-by-Step: How to Modify a Submitted PIW**

1. On the submitted PIW page, click **"Options"** next to the version
2. Select **"Duplicate as Draft"** — this creates a copy in the Drafts section with all previously entered information
3. Open the draft, make your edits, and click Submit
4. A new Version of the PIW will appear in the Submitted Versions section
5. OPSC staff will review and Approve or Revoke as necessary

**Note:** Subsequent versions of a PIW are for the **same phase** (e.g., Fund Release submittal). For a **new phase** (e.g., First Expenditure Report), you must use "Create Linked PIW" again from the application page and follow the creation process from step 3 above.

**PIW Instructions reference:** https://www.dgs.ca.gov/-/media/Divisions/OPSC/Resources/PIW_Instructions.pdf
**PIW online submission:** https://www.dgsapps.dgs.ca.gov/opsc/piw/
**Support:** Contact your OPSC Project Manager or email OPSCApplicationReviewTeam@dgs.ca.gov

---

### STATE ALLOCATION BOARD (SAB) — RULES AND OPERATING PROCEDURES (Amended September 19, 2012)

**What is the SAB?**
The State Allocation Board (SAB) allocates School Facility Program (SFP) funding for eligible school districts. It is the governing body that approves construction and modernization grants.

**SAB Membership** (10 members total):
- Director of Finance
- Director of the Department of General Services
- Superintendent of Public Instruction
- Three members of the Senate
- Three members of the Assembly
- One appointee by the Governor

---

**SAB Meetings:**
- **Regular meetings:** Fourth Wednesday of each month (subject to change with Board approval)
- **Quorum:** 6 members (majority of the Board) required to transact business
- **Notice:** Posted 10 days prior per Bagley-Keene Open Meeting Act (Government Code 11120–11132)
- **Voting:** Motions require a second; unanimous roll call allows single vote on Consent, Appeal, Action, and Discussion items; any member may request a voice roll call vote on any item

**Standard Order of Business at SAB Meetings:**
1. Quorum Call
2. Minutes
3. Executive Officer's Report
4. Consent
5. Appeals
6. Action Items
7. Reports, Discussion, and Information Items
8. Public Comment
9. Board Member Requests for Future Agenda Items
10. Adjournment

**Consent Calendar:** Any Board Member may pull an item from Consent for separate consideration and vote. A pulled item becomes the next order of business after the remaining Consent items are approved.

**Agenda Item Limits:** Board items may be set on the agenda no more than **3 times**, unless new information is available. Exceptions include: no quorum, Board Member requests to put over, district unable to attend, joint withdrawal by district and OPSC, staff analysis not distributed 72 hours in advance, Board Member requests more information, Chair pulls an item, or an Appeals item is postponed by OPSC.

---

**Filing an Appeal (District Appeals Process):**

**Step 1 — File Form SAB 189:** When a school district disagrees with OPSC on an item, the district must file a **School District Appeal Request (Form SAB 189)** with the OPSC. The form must state the basis for the appeal and any relevant information for resolving the dispute.

**Step 2 — Acknowledgement:** Within **5 working days** of receiving the appeal, the OPSC analyst sends an acknowledgement letter confirming receipt and providing the expected SAB meeting date (but no later than 120 days from receipt of Form SAB 189). A copy goes to the Assistant Executive Officer and Chair of the Board.

**Timelines:**
- Standard policy appeal: **90–120 days** from receipt to SAB meeting
- Health and safety appeals: **60–90 days** (takes precedence)

**Postponement of Appeals:**
- A district or OPSC may request postponement in writing to the Chair and Vice Chair at any time before the SAB meeting, with reasons stated
- First postponement request: **automatically approved**
- Second postponement request: subject to Chair and Vice Chair approval; response communicated within 2 working days; if approved, new SAB meeting notice sent at least 15 days before new date

**Appeal Vote Requirement:**
Staff analyses for appeals include an Options section. A **positive vote by 6 members of the Board is required** to take action that is an alternative to OPSC staff's administrative action. If 6 members do not vote in favor, staff's administrative action stands and the appeal is considered closed.

---

**Staff Analyses:**
- Posted to the internet at least **3 working days** before the meeting (5 working days for appeals)
- **Policy item format:** Purpose, Description, Authority (Law/Regulation/Precedent), Background, Staff Analysis/Statements, Recommendation
- **Appeal item format:** Purpose, Description, Authority, Background (including timeline of events and prior Board actions), Staff Analysis/Statements, Options
- Background for Financial Hardship items must include the date and amount of the last approved district bond and subsequent bond efforts

**Public Comment:** Included at the end of every SAB agenda for testimony on items not on the agenda.

**Subcommittees and Working Groups:**
- The Chair or any Board Member (with majority concurrence) may create a subcommittee or working group
- Subcommittees: minimum 3 appointed Board Members; subject to Bagley-Keene Open Meeting Laws; webcasted
- Working Groups: membership determined by the Board; subject to Bagley-Keene and webcasted
- Actions of subcommittees are proposals/recommendations only — they have no binding effect without full Board action

**Procedural Authority:** California Senate Rules, with Mason's Manual of Legislative Procedure as default for matters not covered by the SAB rules.

**Closed Session:** The Board may meet in closed session for pending/ongoing litigation (Gov. Code 11126(e)) and employment/personnel matters (Gov. Code 11126(a)).

---

## ADDITIONAL DATASET — FORM INSTRUCTIONS (SAB 50-04, SAB 50-09, SAB 50-10)

---

### SAB 50-04 — APPLICATION FOR FUNDING (REV 08/25) — DETAILED SECTION INSTRUCTIONS

**Overview:** Form SAB 50-04 is the primary funding application for the School Facility Program. It covers New Construction, Modernization, Facility Hardship, Seismic Mitigation, Final Charter School Apportionment, Overcrowding Relief Grant (ORG), and all Separate Apportionments (site-only, design-only, advance funding). A PTN must be assigned before submission.

**Insufficient Bond Authority (ARBBA):** If submitted when there is Insufficient Bond Authority (Section 1859.2), the district must adopt and submit a school board resolution per Regulation Section 1859.95.1.

**Section 1 — Type of Application (check only one):**
New Construction | New Construction Final Apportionment | New Construction Final Charter School Apportionment | New Construction (Overcrowding Relief Grant) | Rehabilitation (Final Charter School Apportionment) | Modernization | Modernization of California Schools for Deaf/Blind | Facility Hardship [1859.82.1] (with sub-options: Conceptual Approval, Replacement Site, Replacement School Buildings, 60% Rehabilitation Costs) | Seismic Mitigation [1859.82.2] (sub-options: Conceptual Approval, Replacement Site, Replacement School Buildings, 60% Seismic Rehabilitation Grant Costs) | Separate Apportionments: Site Only (New Construction, District-Owned, Environmental Hardship, Facility Hardship, Seismic Mitigation); Design Only (New Construction, Modernization, Facility Hardship, Seismic Mitigation, with or without High Performance); Advance Funding for Evaluation and RA. To convert Preliminary to Final: check the appropriate Final Apportionment box.

**Section 2 — Type of Project:**
- 2a: Select school type and enter pupils by grade group (K–6, 7–8, 9–12, Non-Severe, Severe). Cannot exceed SAB 50-03 baseline eligibility. For Final Apportionment, pupils must be 75–100% of Preliminary Apportionment.
- 2b: 50 Years or Older Building Funding (Modernization only) — report eligible classrooms/sq footage, 50-year ratio, and resulting pupil grants.
- 2c: Pupils from Alternative Enrollment Projection (New Construction only).
- 2d: 75 Years or Older Facilities (Modernization only) — classrooms/sq footage demolished and constructed, associated pupil grants.
- 2e: 6–8 school or Alternative Education School.
- 2f: Use of grant per Section 1859.77.2 or 1859.77.3 — requires board resolution and housing plan.
- 2g: Charter School Facilities Rehabilitation — enter toilet and other sq footage.
- 2h: Site scenario (Leased Site, New Site, Existing Site with/without Additional Acreage).
- 2i: ORG projects — list eligible school sites, portables replaced, and site-specific eligible pupils.

**Section 3 — Number of Classrooms:** Enter classrooms per P&S (net increase if demolition occurred), master plan acreage, CDE recommended site size, existing and proposed useable acres.

**Section 4 — Financial Hardship Request:** Check if district cannot meet matching share requirement. Options: (1) pending OPSC approval per Section 1859.81(h), or (2) school board resolution per Section 1859.95.1 (Insufficient Bond Authority).

**Section 5 — New Construction Additional Grant Request:**
- 5a: Therapy area sq footage (toilet and other per Section 1859.72)
- 5b: Multilevel Construction (CRS) per Section 1859.73
- 5c: Project Assistance per Section 1859.73.1 — requires current SAB 50-01 if not previously submitted district-wide
- 5d: Site Acquisition — enter 50% of: (1) actual cost, (2) appraised value, (3) relocation cost, (4) 2% of lesser of cost or appraised value (minimum $25,000), (5) DTSC fee. Note: LPP Priority 2 sites ineligible. District-owned sites acquired with LPP/SFP/Prop 1A funds ineligible under Section 1859.74.5.
- 5e: 50% of hazardous materials/waste removal — check RA box if required
- 5f: Site Development — 50% of service-site, off-site, and utility costs per Section 1859.76; check General Site if applicable. All cost estimates must reflect 100% of proposed work.
- 5g: Energy Efficiency — % exceeding Title 24 per Section 1859.71.3
- 5h: Fire Code — Automatic Fire Detection/Alarm System or Automatic Sprinkler System
- 5i: High Performance Incentive — indicate HPI points per Section 1859.71.6 or 1859.77.4
- 5j: Multilevel Construction (Replaced Facilities) — toilet and other sq footage

**Section 6 — Modernization Additional Grant Request:**
- 6a: Project Assistance per Section 1859.78.2
- 6b: Energy Efficiency — % exceeding Title 24 per Section 1859.78.5
- 6c: Site Development — 60% of eligible utility costs for 50+ year buildings per Section 1859.78.7(a)
- 6d: Site Development — 60% of eligible utility costs for 75+ year buildings per Section 1859.78.7(a)
- 6e: Fire Code requirements per Section 1859.78.4
- 6f: High Performance Incentive per Section 1859.77.4
- 6g: Minimum Essential Facility (MEF) — select type (Multipurpose, Gymnasium, Library, Kitchen, Hybrid); enter toilet/other sq footage; permanent or portable; 35% of supplemental grant OR 60% of minimum work amount; Site Development option per Section 1859.78.9.1
- 6h(1): Transitional Kindergarten (TK) Classrooms — New Construction or Retrofit; number of classrooms; fire alarm/sprinkler/multilevel/50-year utilities options; Site Development 35% or 60% option per Section 1859.78.9.2
- 6h(2): TK Enrollment Data — enter TK–3 enrollment for current year and three prior years. Applications filed on or after November 1 must include current school year enrollment.

**Section 7 — Excessive Cost Hardship Request:**
- New Construction: Geographic Percent Factor; New School Project [1859.83(c)(1) or (c)(2)]; Small Size Project; Urban/Security/Impacted Site (enter $/useable acre for new sites)
- Modernization: Geographic Percent Factor; Small Size; Urban/Security/Impacted Site; Accessibility/Fire Code — 3% of base grant OR 60% of minimum work amount (attach DSA-approved list of minimum work); Number of 2-Stop Elevators; Number of Additional Stops

**Section 8 — Charter School Facilities Program Rehabilitation Additional Grant and ECH:**
- 8a: High Performance Incentive per Section 1859.77.4
- 8b–8e: Excessive Cost Hardship for: Geographic Location [1859.167.3(a)], Small Size [1859.167.3(b)], Urban/Security/Impacted Site [1859.167.3(c)], Accessibility/Fire Code [1859.167.3(d)] — 3% of CSFP Rehab grant OR 50% of minimum work

**Section 9 — Project Priority Funding Order (New Construction Only):** Enter priority among same-day submissions. Check applicable criteria: density [1859.92(c)(3)], stock plans [1859.92(c)(4)], energy efficiency [1859.92(c)(6)].

**Section 10 — Prior Approval Under the LPP:** Report Phase P/S/C LPP application numbers (NC: 22/, Mod: 77/).

**Section 11 — Prior Apportionment Under the SFP:** Report prior site/design SFP apportionment numbers (Site/Design–NC: 50/, Design–Mod: 57/).

**Section 12 — Preliminary to Final Apportionment:** Enter the Preliminary Apportionment application number when converting.

**Section 13 — Alternative Developer Fee (New Construction Only):** Report alternative developer fees collected under Government Code Section 65995.7 as of application submittal date per Section 1859.77.

**Section 14 — Adjustment to New Construction Baseline Eligibility:** Report additional and replacement classrooms provided since baseline eligibility, by grade level, with construction contract date.

**Section 15 — Pending Reorganization Election (New Construction Only):** Indicate if pending reorganization will result in loss of eligibility. If yes, submit SAB 50-01, 50-02, and 50-03 with this application.

**Section 16 — Joint-Use Facility/Leased Property:** Check (a) joint use with governmental agencies, or (b) grants used for facilities on leased property.

**Section 17 — Project Progress Dates:** Construction contract award date(s); Notice to Proceed date(s); LCP status (pre-January 1, 2012 contracts).

**Section 18 — Prevailing Wage Monitoring (Jan 1, 2012 – June 19, 2014 contracts):** DIR Public Works, DIR-approved LCP, or collective bargaining agreement per Labor Code Section 1771.3(b)(3).

**Section 19 — Construction Delivery Method:** Design-Bid-Build; Design-Build; Developer Built; Lease Lease-Back; Energy Performance Contract; Piggyback contract; Other.

**Section 20 — CTE Funds Request:** Indicate if CTE funds will be requested for classrooms in the P&S per Section 1859.193; enter number of CTE classrooms.

**Section 21 — Overcrowding Relief Grant Narrative:** Provide explanation or attach signed letter detailing how the project will relieve overcrowding.

**Section 22 — Local Funding Adjustment Grant:**
- 22a: Total assessed valuation (with county auditor-controller letter)
- 22b: Gross bonding capacity = assessed valuation × 1.25% (non-unified) or 2.5% (unified)
- 22c: Unduplicated pupil percentage per Education Code Section 42238.02
- 22d: CBEDS enrollment per SAB 50-01 criteria; if filed on or after November 1, use current school year
- 22e: Project Labor Agreement — Yes/No

**Section 23 — Architect of Record or Licensed Architect Certification:** Certifies P&S submitted to OPSC electronically; DSA approval date entered; Title 24 compliance for non-DSA portions; net classroom difference (demolished vs. constructed) for Modernization/CSFP Rehab.

**Section 24 — Architect of Record or Design Professional Certification:** Certifies construction cost estimate is at least 60% of total grant + district match (less site acquisition and HPI Base Grant). For 75+ Year Buildings, MEF, or TK projects, cost estimate must separately delineate qualifying facility costs.

**Section 25 — District Representative Certification:** Certifies all statutory requirements including: authorized representative; board resolution; Restricted Maintenance Account; joint-use feasibility; DSA and CDE plan approvals; matching share deposited; Public Contract Code compliance; LCP/prevailing wage compliance; substantial progress (18 months from apportionment, or 12 months for Section 1859.75.1 projects); funds not released within 18 months rescinded per Section 1859.90; ARBBA board resolution; Project Labor Agreement compliance; TK/MEF classroom certifications.

---

### SAB 50-09 — CHARTER SCHOOL PRELIMINARY APPORTIONMENT — DETAILED SECTION INSTRUCTIONS

**Overview:** Form SAB 50-09 is used to request a Preliminary Apportionment for new construction or rehabilitation of charter school facilities. May be filed by the Charter School directly or by the school district on behalf of the Charter School (if located within district boundaries). A PTN is required. The apportionment is a reservation of funds until full Charter School Apportionment per Sections 1859.165–1859.166.1.

**Who Can File:** (1) School district on behalf of Charter School; or (2) Charter School on its own behalf — only if the Charter School has notified both the superintendent and governing board in writing at least 30 days prior to submission. Notice must request enrollment certification per Section 1859.162.1(a) and state the number of pupils the charter school intends to apply for.

**Required Documents (All Projects):**
- SAB 50-01, 50-02, and 50-03 (if not previously submitted by the school district)
- Verification of Charter School's 30-day written notification to the district (if filing on own behalf)
- Project narrative: estimated scope, projected opening date, charter school general location, whether new construction or rehabilitation, permanent or portable

**Required Documents (New Construction Only):**
- Charter School filing on own behalf: school board resolution certifying unhoused pupils to be housed, supporting documentation, and board meeting minutes
- District filing on behalf: district representative certification of unhoused pupils count
- CDE estimated recommended site size letter
- Appraisal or Preliminary Appraisal of property (or Median Cost documentation) if requesting site acquisition per Section 1859.163.2(a)
- Documentation for relocation and DTSC costs if requesting other than 15% standard allowance
- Cost estimate for site development if requesting other than $70,000/acre standard

**Required Documents for Site Acquisition per Section 1859.164.2(b):** Contingent CDE site approval letter; preliminary appraisal of property.

**Required Documents (Rehabilitation Only):**
- Agreement between district and Charter School for use of facilities (must be discussed and approved at a board meeting)
- Site drawing identifying all classrooms and subsidiary facilities with sq footage and age of each building

**Financial Soundness Requirement:** New construction or rehabilitation funding is available only to applicants with current CSFA financial soundness status.

**Section 1 — Type of Application:** New Construction Preliminary Charter School Apportionment | Site Acquisition Costs [Section 1859.164.2(b)] | Rehabilitation Preliminary Charter School Apportionment. If requesting site acquisition costs from a previously approved Preliminary Apportionment, complete boxes 2, 3, 4, and site acquisition data in 5b only.

**Section 2 — Type of Project:** School type (Elementary, Middle, High School); name of school district where charter school is physically located.

**Section 3 — Number of Classrooms/Useable Acres:** Estimated classrooms; existing useable acres (if addition); proposed useable acres to be acquired (must be obtained from CDE before submission).

**Section 4 — Additional Project Information (New Construction Only):**
- 4a: Project capacity by grade level (K–6, 7–8, 9–12, Non-Severe, Severe)
- 4b: District's unhoused pupils to be housed in the charter school, by grade level, per Section 1859.162.1(a) or 1859.162.2(b)
- 4c: Addition to existing site? Yes/No; if yes, enter school name

**Section 5 — Increase in Preliminary Apportionment (New Construction Only):**
- 5a: Multilevel Construction per Section 1859.163.1(a)(2)
- 5b: Site Acquisition — (1) 50% of appraised/preliminary appraised value or Median Cost; if using Median Cost, enter nearest street intersection; (2) Relocation/DTSC cost: 15% standard OR 50% of specific/historic cost with documentation; (3) Hazardous material cleanup: 50% of allowable amount per Section 1859.163.2(d)
- 5c: Site Development — $70,000/proposed useable acre OR 50% of specific/historic cost with cost estimate per Section 1859.76; check General Site if applicable
- 5d: Geographic Percent Factor
- 5e: Small Size Project per Section 1859.163.1(a)(5)
- 5f: Urban Allowance per Section 1859.163.1(a)(6)

**Section 6 — Additional Project Information (Rehabilitation Only):** Square footage of non-toilet facilities and toilet facilities in the rehabilitation project.

**Section 7 — Increase in Preliminary Apportionment (Rehabilitation Only):**
- 7a: Geographic Percent Factor per Section 1859.163.5(a)(4)
- 7b: Small Size Project per Section 1859.163.5(a)(2)
- 7c: Urban/Security/Impacted Site per Section 1859.163.5(a)(3)
- 7d: New DSA-required two-stop elevator(s) — attach DSA letter requiring elevator; enter number of 2-stop elevators
- 7e: Number of additional stops beyond two on new DSA-required elevator(s)

**Section 8 — Project Progress Dates:** (a) Construction contract award date(s) or N/A; (b) Notice to Proceed issue date or N/A; (c) LCP status for contracts awarded before January 1, 2012.

**Section 9 — Prevailing Wage Monitoring (Jan 1, 2012 – June 19, 2014 contracts):** DIR Public Works, DIR-approved internal LCP, or collective bargaining agreement per Labor Code Section 1771.3(b)(3).

**Section 10 — Priority Order:** Enter priority order among same-date Preliminary Charter School Apportionment applications within the same school district.

**Section 11 — Charter School Information:**
- 11a: Current enrollment (used to determine Small, Medium, or Large per Section 1859.2)
- 11b: Not-for-profit? Must comply with Non-Profit Entity definition in Section 1859.2
- 11c: Locale code — Rural, Suburban, or Urban per Section 1859.2
- 11d: Free/Reduced Lunch percentage (determines low-income status per Sections 1859.2 and 1859.164.1(a))
- 11e: Additional application number if Charter School filed a separate application under Section 1859.162.1

**Section 12 — Certification:**
- Part A: Charter School authorized representative (filing on own behalf) — certifies 30-day advance notification to district
- Part B: School district authorized representative (filing on behalf of Charter School) — certifies: board resolution; consideration of existing facilities per Section 17078.53(e); rehabilitation agreement if applicable; unhoused pupils certification for NC; Restricted Maintenance Account per Ed Code 17070.75/17070.77; joint-use feasibility; Public Contract Code compliance; competitive architect selection; 3% disabled veteran expenditure goal; substantial progress obligations; material inaccuracy penalty acknowledgment; CSFA financial soundness; leased land requirements; conversion to Final Apportionment subject to Section 1859.167; facilities inspection system per Ed Code 17070.75(e)

**Enrollment Update Requirement:** If requesting a Preliminary Apportionment after initial baseline eligibility was approved, and the current CBEDS year is later than the year used for baseline, the district must submit a new SAB 50-01 with current CBEDS data, a revised SAB 50-02, and a revised SAB 50-03 (unless already done). Small districts (2,500 or fewer pupils) have eligibility adjusted per Section 1859.51(j).

---

### SAB 50-10 — CAREER TECHNICAL EDUCATION FACILITIES PROGRAM (CTEFP) — DETAILED SECTION INSTRUCTIONS

**Overview:** Form SAB 50-10 is used by a school district or JPA to request a CTEFP grant for new construction or modernization of CTE facilities. A PTN must be assigned. The district locale must be entered for all CTE applications. If amending only the HPI grant request, complete Sections 1 and 14 only.

**Required Documents:**
- CDE CTE score letter (minimum 105 points required)
- Copy of submitted CTEFP application per Ed Code Section 17078.72
- CDE Plan Approval letter (if applicable)
- DSA-approved P&S with DSA Approval letter (if applicable; may be submitted on CD-ROM or Zip Drive in AutoCAD 14)
- Detailed site development cost estimate (if requesting site development funding)
- Detailed construction cost estimate (if requesting construction funding)
- Itemized equipment list with costs (if requesting equipment funding)
- Completed CTEFP Funding Availability Worksheet (if requesting a loan per Section 1859.194)

**Section 1 — Type of Application:** New Construction Project (new buildings and/or equipment) | Modernization Project (reconfigure existing buildings and/or equipment) | Separate HPI Grant Request [Section 1859.107]: Add the HPI Grant or Remove the HPI Grant.

**Section 2 — CTE Industry Sector and Pathway(s):** Enter the Industry Sector name and all applicable Pathway(s).

**Section 3 — Reservation of Funds:** Yes if requesting a reservation per Section 1859.193(d). With a reservation, the district must submit necessary approvals and/or P&S within 1 year of apportionment or funds are rescinded without further Board action.

**Section 4 — Loan Request:** Yes if requesting a loan per Section 1859.194. A CTEFP Loan Agreement must be executed. Matching funds must be received/expended or deposited in County School Facility Fund prior to notice of completion.

**Section 5 — Number of CTE Classrooms:** Enter the number of CTE classrooms as specified in the CDE CTE Application.

**Section 6 — Qualifying SFP Project Application Number:** If CTEFP project is part of a qualifying SFP project, enter the SFP application number or PTN per Section 1859.193.1.

**Section 7 — CDE Application Overall Score:** Enter score from the CDE CTE score letter. Minimum required: 105 points per Section 1859.192(c).

**Section 8 — CTE Facility Square Footage:** Total eligible square footage of the CTE Facility.

**Section 9 — Eligible Costs:**
- 9a: 50% of construction cost (new building area, modernization, or reconfiguration)
- 9b: 50% of equipment cost per Ed Code Section 17078.72(a)
- 9c: 50% of site development costs (only if NOT part of a qualifying SFP project)
- 9d: 50% of SFP New Construction Grant allowance for CTE classrooms (only if IS part of a qualifying SFP project per Section 1859.193(a)(1)(C))
- 9e: Total = 9a + 9b + 9c − 9d

**Section 10 — Cost Per Square Foot:** Total eligible costs (Section 9 at 100%) ÷ CTE facility sq footage (Section 8).

**Section 11 — Project Assistance:** Check if requesting project assistance per Section 1859.73.1. Available only to CTE projects NOT part of a qualifying SFP New Construction or Modernization project.

**Section 12 — Project Progress Dates:** (a) Construction contract award date(s) or N/A; (b) Notice to Proceed date or N/A.

**Section 13 — Prevailing Wage Monitoring (Jan 1, 2012 – June 19, 2014 contracts):** DIR Public Works, DIR-approved internal LCP, or collective bargaining agreement per Labor Code Section 1771.3(b)(3).

**Section 14 — High Performance Incentive (HPI) Additional Grant:** Check box if requesting Additional Grant for HPI per Ed Code Section 17078.72, Subdivision (I). If DSA has approved P&S, enter HPI points per Section 1859.71.6 or 1859.77.4. Note: HPI reserved funds will be rescinded if required points are not attained when P&S are submitted.

**Section 15 — Certification:** District or JPA representative certifies: authorized representative; board resolution; Restricted Maintenance Account; matching funds compliance; DSA plan approval; CDE plan approval; Section 1859.76 compliance; lease agreement if applicable; CTEFP eligibility criteria per Section 1859.192; all construction laws; 18-month fund release deadline (rescinded if not released per Section 1859.197); 1-year reservation deadline; 18-month substantial progress requirement (Section 1859.198); audit/repayment obligations; competitive architect selection; Public Contract Code compliance; post-May 20, 2006 construction/equipment requirement; loan agreement if applicable; prevailing wage compliance; 3% disabled veteran expenditure goal; high performance school design consideration; governing board HPI resolution; OPSC form verbatim certification.

**Key CTEFP Deadlines:**
- Funds not released within **18 months** of apportionment shall be rescinded and application denied (Section 1859.197)
- Reservation of Funds: P&S must be submitted within **1 year** of apportionment or funds rescinded (Section 1859.197)
- Lack of substantial progress within **18 months** of receipt of funding causes rescission of unexpended funds (Section 1859.198)

**CTEFP Eligibility Summary:**
- Applicant must be a Comprehensive High School per Ed Code 51224, 51225.3, 51228 or a JPA operating CTE programs as of May 20, 2006
- Active CTE advisory committee required
- Minimum CDE score: 105 points
- Maximum grants: New Construction $3 million/project/site; Modernization $1.5 million/project/site
- 50/50 matching program
- For modernization: construction contracts must be executed on or after May 20, 2006
- For new construction: CTE classrooms must not have been occupied before May 20, 2006
- All equipment must be purchased on or after May 20, 2006 (unless combined with qualifying SFP NC project)`;


const TOPIC_CATEGORIES = [
  {
    id: "nav",
    icon: "⚙️",
    label: "Navigation",
    topics: [
      { label: "Login & Dashboard", q: "How do I access OPSC Online and navigate the Dashboard?" },
      { label: "User Management", q: "How do I manage users and assign roles in OPSC Online?" },
      { label: "Revise Application", q: "How do I revise or create a new draft of an existing application?" },
      { label: "Upload & Submit", q: "How do I upload documents and submit a completed application?" },
    ],
  },
  {
    id: "elig",
    icon: "✅",
    label: "Eligibility",
    topics: [
      { label: "SAB 50-03 Eligibility", q: "Walk me through submitting a SAB 50-03 Eligibility Determination form step by step." },
      { label: "NC Eligibility (50-01/02/03)", q: "How do I establish New Construction eligibility using SAB 50-01, SAB 50-02, and SAB 50-03?" },
      { label: "MOD Eligibility Checklist", q: "What documents are required to establish or update Modernization Eligibility using Form SAB 50-03?" },
    ],
  },
  {
    id: "fund",
    icon: "💰",
    label: "Funding Apps",
    topics: [
      { label: "Modernization 50-04", q: "Walk me through creating a Modernization Funding Application SAB 50-04 Full Grant step by step." },
      { label: "New Construction 50-04", q: "Walk me through creating a New Construction Funding Application SAB 50-04 step by step." },
      { label: "Advance Funding", q: "How do I apply for Advance Site, Advance Design, or Advance Site and Design funding?" },
      { label: "Charter School 50-09", q: "How do I create a Charter School Facilities Program application SAB 50-09?" },
      { label: "Pre-K / TK 70-01", q: "How do I create a Pre-K, TK, or Full-Day Kindergarten application SAB 70-01?" },
    ],
  },
  {
    id: "check",
    icon: "📋",
    label: "Checklists",
    topics: [
      { label: "50-04 Submittal Checklist", q: "What documents are required on the SAB 50-04 submittal checklist for New Construction, Modernization, and Facility Hardship?" },
      { label: "MOD Funding Checklist", q: "What documents are required to submit a Modernization Funding Application Form SAB 50-04?" },
      { label: "50-05 Fund Release", q: "What are the SAB 50-05 Fund Release Authorization requirements and what documents do I need to submit?" },
      { label: "Facility Hardship Docs", q: "What documents are required for a complete Facility Hardship application? Walk me through the checklist." },
    ],
  },
  {
    id: "special",
    icon: "🏗️",
    label: "Special Programs",
    topics: [
      { label: "Facility Hardship", q: "How do I apply for Facility Hardship or Seismic Mitigation Program funding?" },
      { label: "Seismic Mitigation", q: "What are the Seismic Mitigation Program requirements, phases, and required documents?" },
      { label: "Architect Guidelines", q: "What are the Architect Submittal Guidelines requirements for plans and cost estimates for SFP applications?" },
      { label: "Cost Reduction", q: "What are the OPSC Cost Reduction Guidelines and key strategies for reducing school construction costs?" },
    ],
  },
  {
    id: "tools",
    icon: "📚",
    label: "Tools & Guides",
    topics: [
      { label: "PIW User Guide", q: "How do I create, complete, and submit a Project Information Worksheet (PIW) in OPSC Online? Walk me through it step by step." },
      { label: "PTN Guide", q: "What is a Project Tracking Number PTN and how do I find and update it?" },
      { label: "Enrollment Calculator", q: "How do I use the Enrollment Projection Calculator in OPSC Online?" },
      { label: "SFP Glossary", q: "Explain the most important SFP terms and abbreviations for a new user." },
    ],
  },
  {
    id: "sab",
    icon: "⚖️",
    label: "SAB Process",
    topics: [
      { label: "SAB Meeting Process", q: "How does the State Allocation Board (SAB) meeting process work? What is the order of business and how are items approved?" },
      { label: "Filing a SAB Appeal", q: "How do I file a school district appeal with the State Allocation Board? Walk me through the Form SAB 189 process, timelines, and what I need to know." },
      { label: "SAB Membership & Rules", q: "Who are the members of the State Allocation Board and what are the key rules governing SAB meetings and procedures?" },
    ],
  },
];

const QUICK_STARTS = [
  "How do I start a new SFP funding application?",
  "What are the Modernization eligibility requirements?",
  "What funding programs are available?",
  "Explain SFP terms and abbreviations.",
];

const LANGS = {
  en: "Ask about SFP programs, eligibility, forms, or OPSC Online navigation…",
  es: "Pregunte sobre programas SFP, elegibilidad, formularios o navegación OPSC Online…",
  zh: "询问SFP项目、资格要求、表格或OPSC Online操作…",
};

// ── Decision Tree Wizard ────────────────────────────────────────────────────
const WIZARD_TREE = {
  nodes: {
    start: {
      q: "What are you trying to accomplish?",
      hint: "Select the option that best describes your goal.",
      choices: [
        { label: "🏗️  Apply for construction or renovation funding", next: "typeOfWork"  },
        { label: "✅  Establish or update project eligibility",        next: "eligType"   },
        { label: "🏫  Charter school facility project",                next: null, result: "charter"       },
        { label: "👶  Pre-K / TK / Full-Day Kindergarten project",     next: null, result: "preK"          },
        { label: "⚠️  Health/safety issue or seismic risk",           next: "hardshipType"                },
        { label: "📋  Get help with a specific form",                  next: "formHelp"  },
      ],
    },
    typeOfWork: {
      q: "What type of construction are you planning?",
      hint: "",
      choices: [
        { label: "🆕  New school construction",              next: "ncEligCheck"   },
        { label: "🔧  Modernization / renovation",           next: "modAge"        },
        { label: "🌍  Site acquisition only (Advance Site)", next: null, result: "advanceSite"    },
        { label: "📐  Design costs only (Advance Design)",   next: null, result: "advanceDesign"  },
      ],
    },
    modAge: {
      q: "How old is the building being modernized?",
      hint: "Building age for SFP purposes begins 12 months after DSA plan approval.",
      choices: [
        { label: "25 years or older  ✅",          next: "modType"               },
        { label: "Less than 25 years  ❌",          next: null, result: "modTooNew"    },
        { label: "I'm not sure — need to verify", next: null, result: "modCheckAge"  },
      ],
    },
    modType: {
      q: "Which modernization grant type applies to your project?",
      hint: "",
      choices: [
        { label: "Full Grant (standard 60% state / 40% district)", next: null, result: "modFull"       },
        { label: "Adjusted Full Grant",                             next: null, result: "modAdjusted"   },
        { label: "Facility Hardship — Rehabilitation",             next: null, result: "hardshipRehab" },
        { label: "Not sure — help me decide",                       next: null, result: "modHelp"       },
      ],
    },
    ncEligCheck: {
      q: "Where are you in the New Construction eligibility process?",
      hint: "NC eligibility requires three approved forms before you can apply for funding.",
      choices: [
        { label: "All three approved — SAB 50-01, 50-02, and 50-03", next: null, result: "ncFunding"   },
        { label: "SAB 50-01 approved, need SAB 50-02 next",          next: null, result: "ncNeed5002"  },
        { label: "SAB 50-01 & 50-02 approved, need SAB 50-03",       next: null, result: "ncNeed5003"  },
        { label: "Starting from scratch — nothing approved yet",      next: null, result: "ncStart"     },
      ],
    },
    eligType: {
      q: "Which type of eligibility are you establishing?",
      hint: "",
      choices: [
        { label: "Modernization eligibility (SAB 50-03)",           next: null, result: "modElig"   },
        { label: "New Construction eligibility (SAB 50-01/02/03)",  next: null, result: "ncStart"   },
        { label: "I'm not sure which one I need",                    next: null, result: "eligHelp"  },
      ],
    },
    hardshipType: {
      q: "What is the nature of the issue?",
      hint: "",
      choices: [
        { label: "⚠️  Active health or safety threat (non-seismic)", next: null, result: "hardshipFull"   },
        { label: "🌍  Seismic / earthquake safety risk",             next: null, result: "seismic"         },
        { label: "🔍  Not sure — I need to assess eligibility",      next: null, result: "hardshipCheck"   },
      ],
    },
    formHelp: {
      q: "Which form do you need guidance on?",
      hint: "",
      choices: [
        { label: "SAB 50-01  — Enrollment Certification Projection", next: null, result: "form5001"  },
        { label: "SAB 50-03  — Eligibility Determination",           next: null, result: "form5003"  },
        { label: "SAB 50-04  — Funding Application",                 next: null, result: "form5004"  },
        { label: "SAB 50-05  — Fund Release Authorization",          next: null, result: "form5005"  },
        { label: "SAB 50-09  — Charter School Program",              next: null, result: "form5009"  },
        { label: "PIW  — Project Information Worksheet",             next: null, result: "formPIW"   },
      ],
    },
  },
  results: {
    modFull:       { icon: "🔧", title: "Modernization Full Grant — SAB 50-04",              color: "#1A3B6F", summary: "Your project qualifies for a Modernization Full Grant. The state funds 60% and your district contributes 40%.", action: "Walk me through creating a Modernization Full Grant SAB 50-04 application step by step." },
    modAdjusted:   { icon: "🔧", title: "Modernization Adjusted Full Grant — SAB 50-04",     color: "#1A3B6F", summary: "Your project may qualify for an Adjusted Full Grant based on your eligibility adjustments.", action: "What is a Modernization Adjusted Full Grant and how do I apply for it with SAB 50-04?" },
    modTooNew:     { icon: "⚠️", title: "Building May Not Qualify Yet",                       color: "#B45309", summary: "Standard SFP Modernization requires buildings to be 25+ years old. Your building may not be eligible yet.", action: "What are the building age requirements for Modernization eligibility under SFP rules, and are there any exceptions?" },
    modCheckAge:   { icon: "📋", title: "Verify Building Age for Modernization",              color: "#1A3B6F", summary: "Building age for SFP purposes begins 12 months after DSA plan approval — not the construction date.", action: "How do I determine if my building is old enough for Modernization eligibility under SFP rules?" },
    modHelp:       { icon: "❓", title: "Modernization Grant Type Guidance",                  color: "#1A3B6F", summary: "Let me help you determine whether Full Grant or Adjusted Full Grant applies to your situation.", action: "What is the difference between a Modernization Full Grant and an Adjusted Full Grant for SAB 50-04?" },
    modElig:       { icon: "✅", title: "Modernization Eligibility — SAB 50-03",              color: "#1E7B34", summary: "You need to establish Modernization eligibility using Form SAB 50-03 before applying for funding.", action: "Walk me through submitting a SAB 50-03 Modernization Eligibility Determination form step by step." },
    ncStart:       { icon: "🆕", title: "New Construction — Start with SAB 50-01",           color: "#1A3B6F", summary: "New Construction requires three eligibility steps before funding: SAB 50-01 → SAB 50-02 → SAB 50-03.", action: "How do I establish New Construction eligibility using SAB 50-01, SAB 50-02, and SAB 50-03?" },
    ncNeed5002:    { icon: "🆕", title: "Next Step: SAB 50-02 School Building Capacity",     color: "#1A3B6F", summary: "Your SAB 50-01 is approved. Complete SAB 50-02 to establish existing school building capacity.", action: "Walk me through completing the SAB 50-02 School Building Capacity form step by step." },
    ncNeed5003:    { icon: "🆕", title: "Next Step: SAB 50-03 NC Eligibility Determination", color: "#1A3B6F", summary: "SAB 50-01 and 50-02 are approved. Complete SAB 50-03 to finalize New Construction eligibility.", action: "How do I complete a SAB 50-03 Eligibility Determination for New Construction?" },
    ncFunding:     { icon: "🏗️", title: "Ready for New Construction Funding — SAB 50-04",   color: "#1E7B34", summary: "Eligibility is complete. You are ready to apply for New Construction funding using Form SAB 50-04.", action: "Walk me through creating a New Construction Funding Application SAB 50-04 step by step." },
    advanceSite:   { icon: "🌍", title: "Advance Site Funding — SAB 50-04",                  color: "#1A3B6F", summary: "You may qualify for Advance Site funding to acquire land before full construction funding.", action: "How do I apply for Advance Site funding using SAB 50-04? What are the requirements and checklist?" },
    advanceDesign: { icon: "📐", title: "Advance Design Funding — SAB 50-04",                color: "#1A3B6F", summary: "You may qualify for Advance Design funding to cover design costs before construction begins.", action: "How do I apply for Advance Design funding using SAB 50-04? What are the requirements?" },
    charter:       { icon: "🏫", title: "Charter School Facilities Program — SAB 50-09",     color: "#1A3B6F", summary: "Charter school projects use Form SAB 50-09 with their own eligibility criteria, scoring, and funding matrix.", action: "How do I create a Charter School Facilities Program application SAB 50-09?" },
    preK:          { icon: "👶", title: "Pre-K / TK / Full-Day Kindergarten — SAB 70-01",   color: "#1A3B6F", summary: "Pre-K, TK, and Full-Day Kindergarten projects use Form SAB 70-01 with linked SAB 70-02 and 70-03 forms.", action: "How do I create a Pre-K, TK, or Full-Day Kindergarten application SAB 70-01?" },
    hardshipFull:  { icon: "⚠️", title: "Facility Hardship Program — SAB 50-04",             color: "#B45309", summary: "Your district may qualify for Facility Hardship funding — Replacement (50/50) or Rehabilitation (60/40).", action: "How do I apply for Facility Hardship funding? Walk me through the requirements, documents, and SAB 50-04 process." },
    hardshipRehab: { icon: "⚠️", title: "Facility Hardship Rehabilitation — SAB 50-04",      color: "#B45309", summary: "If mitigation cost is 50% or less of replacement cost, your project qualifies as Rehabilitation at 60% state funding.", action: "What are the requirements for a Facility Hardship Rehabilitation project and how do I apply with SAB 50-04?" },
    seismic:       { icon: "🌍", title: "Seismic Mitigation Program — SAB 50-04",            color: "#B45309", summary: "The Seismic Mitigation Program (SMP) provides 50/50 state/district funding for seismic repairs or replacement.", action: "What are the Seismic Mitigation Program requirements, four phases, and required documents?" },
    hardshipCheck: { icon: "🔍", title: "Assess Facility Hardship Eligibility",              color: "#1A3B6F", summary: "Let me help determine whether your situation qualifies for Facility Hardship or Seismic Mitigation.", action: "What conditions qualify for the Facility Hardship Program and how is it different from Seismic Mitigation?" },
    eligHelp:      { icon: "✅", title: "Eligibility Pathway Guidance",                       color: "#1A3B6F", summary: "Let me help identify whether you need Modernization or New Construction eligibility for your project.", action: "How do I know whether I need Modernization eligibility or New Construction eligibility for my SFP project?" },
    form5001:      { icon: "📋", title: "SAB 50-01 — Enrollment Certification Projection",   color: "#1A3B6F", summary: "SAB 50-01 certifies pupil enrollment and is the first step toward New Construction eligibility.", action: "Walk me through the SAB 50-01 Enrollment Certification Projection form step by step." },
    form5003:      { icon: "📋", title: "SAB 50-03 — Eligibility Determination",             color: "#1A3B6F", summary: "SAB 50-03 is the core eligibility form for both Modernization and New Construction projects.", action: "Walk me through submitting a SAB 50-03 Eligibility Determination form step by step." },
    form5004:      { icon: "📋", title: "SAB 50-04 — Funding Application",                   color: "#1A3B6F", summary: "SAB 50-04 is the primary funding application for most SFP programs.", action: "Walk me through the SAB 50-04 Funding Application — what sections does it have and how do I complete it?" },
    form5005:      { icon: "📋", title: "SAB 50-05 — Fund Release Authorization",            color: "#1A3B6F", summary: "SAB 50-05 must be submitted within 90 days of apportionment to release your grant funds.", action: "What are the SAB 50-05 Fund Release Authorization requirements and what documents do I need to submit?" },
    form5009:      { icon: "📋", title: "SAB 50-09 — Charter School Facilities Program",     color: "#1A3B6F", summary: "SAB 50-09 is the funding application for Charter School New Construction or Rehabilitation.", action: "How do I create a Charter School Facilities Program application SAB 50-09?" },
    formPIW:       { icon: "📋", title: "PIW — Project Information Worksheet",               color: "#1A3B6F", summary: "The PIW collects data required for fund release authorization and expenditure reporting.", action: "How do I create, complete, and submit a Project Information Worksheet (PIW) in OPSC Online? Walk me through it step by step." },
  },
};

// ── Follow-Up Suggestion Rules ──────────────────────────────────────────────
const FOLLOWUP_RULES = [
  { match: ["login","sign in","dashboard","account","password","userm"],
    chips: [
      { label: "Add or manage users?",        q: "How do I manage users and assign roles in OPSC Online?" },
      { label: "View application status?",    q: "How do I find and check the status of my applications on the OPSC Online dashboard?" },
    ]},
  { match: ["50-01","enrollment","projection","cbeds"],
    chips: [
      { label: "Next step: SAB 50-02?",       q: "I have an approved SAB 50-01 — what do I do next with SAB 50-02?" },
      { label: "Link to SAB 50-03?",          q: "How do I link my SAB 50-01 to the SAB 50-03 Eligibility Determination?" },
      { label: "Update enrollment data?",     q: "Can I update enrollment data in an already approved SAB 50-01?" },
    ]},
  { match: ["50-02","school building capacity","building capacity"],
    chips: [
      { label: "Next step: SAB 50-03?",       q: "I have approved SAB 50-01 and 50-02 — how do I complete SAB 50-03 for New Construction?" },
      { label: "What counts as a classroom?", q: "What types of rooms are counted as classrooms in the SAB 50-02 building capacity form?" },
    ]},
  { match: ["50-03","eligibility determination","modernization eligib","nc eligib"],
    chips: [
      { label: "Documents needed?",           q: "What documents are required to establish Modernization Eligibility using Form SAB 50-03?" },
      { label: "Link to SAB 50-04?",          q: "How do I link my approved SAB 50-03 eligibility to a SAB 50-04 funding application?" },
      { label: "Update existing eligibility?",q: "How do I update an existing Modernization Eligibility with new buildings or enrollment data?" },
    ]},
  { match: ["50-04","funding application","full grant","adjusted full grant","new construction fund","modernization fund"],
    chips: [
      { label: "Submittal checklist?",        q: "What documents are required on the SAB 50-04 submittal checklist?" },
      { label: "How do I submit?",            q: "How do I upload documents and submit a completed SAB 50-04 application?" },
      { label: "How long does review take?",  q: "How long does OPSC take to review a SAB 50-04 funding application after submission?" },
    ]},
  { match: ["50-05","fund release","apportionment","grant release"],
    chips: [
      { label: "90-day deadline details?",    q: "What happens if I miss the 90-day SAB 50-05 submission deadline after apportionment?" },
      { label: "PIW required first?",         q: "Do I need to complete a PIW before submitting the SAB 50-05 Fund Release Authorization?" },
      { label: "New Construction 50-05?",     q: "What parts of SAB 50-05 do I complete for a New Construction apportionment?" },
    ]},
  { match: ["50-09","charter school","csfp","csfa"],
    chips: [
      { label: "Link 50-09 to SAB 50-04?",   q: "After SAB 50-09 approval, how do I create a linked SAB 50-04 application?" },
      { label: "Preference points?",          q: "How are Charter School preference points calculated in the SAB 50-09 application?" },
    ]},
  { match: ["70-01","70-02","pre-k","preschool","full-day kindergarten","transitional kindergarten"],
    chips: [
      { label: "SAB 70-02 Grant Agreement?",  q: "What is the SAB 70-02 Grant Agreement and how do I complete its four parts?" },
      { label: "CALPADS data?",               q: "Where do I find CALPADS enrollment data for my SAB 70-01 application?" },
    ]},
  { match: ["hardship","health and safety","health/safety","replacement project","rehabilitation project"],
    chips: [
      { label: "Replacement vs Rehab?",       q: "What is the difference between a Facility Hardship Replacement and Rehabilitation project?" },
      { label: "Required documents?",         q: "What documents are required for a complete Facility Hardship application?" },
      { label: "Conceptual approval?",        q: "Can I request SAB conceptual approval before I have DSA approved plans for Facility Hardship?" },
    ]},
  { match: ["seismic","earthquake","smp","seismic mitigation"],
    chips: [
      { label: "4 SMP phases explained?",     q: "Explain all four phases of the Seismic Mitigation Program eligibility evaluation process." },
      { label: "DSA concurrence needed?",     q: "What DSA concurrence documents are required at each phase of the Seismic Mitigation Program?" },
    ]},
  { match: ["advance site","advance design","advance funding","site acquisition"],
    chips: [
      { label: "Site-only checklist?",        q: "What documents are required for an Advance Site Only funding application on SAB 50-04?" },
      { label: "Environmental hardship?",     q: "What is the Advance Site Environmental Hardship funding type and who qualifies?" },
    ]},
  { match: ["piw","project information worksheet"],
    chips: [
      { label: "Modify a submitted PIW?",     q: "How do I modify a PIW that has already been submitted in OPSC Online?" },
      { label: "PIW for expenditure report?", q: "Do I need to submit a new PIW with my Expenditure Report (SAB 50-06)?" },
    ]},
  { match: ["ptn","project tracking number"],
    chips: [
      { label: "Link PTN to application?",    q: "How do I link a Project Tracking Number to my SAB 50-04 or SAB 50-09 application?" },
      { label: "Find my PTN?",                q: "Where do I find my Project Tracking Number in OPSC Online?" },
    ]},
  { match: ["architect","submittal guideline","plan verification","cost estimate"],
    chips: [
      { label: "Title sheet requirements?",   q: "What must be included on the title sheet of plans submitted for New Construction?" },
      { label: "Eligible site cost items?",   q: "What site development costs are eligible under CCR Section 1859.76 for SFP?" },
    ]},
  { match: ["cost reduction","construction cost","prototype","joint-use","joint use"],
    chips: [
      { label: "Joint-use opportunities?",    q: "How can joint-use agreements reduce school construction costs under SFP?" },
      { label: "Prototype designs?",          q: "How do prototype school designs reduce construction costs under SAB guidelines?" },
    ]},
  { match: ["sab meeting","state allocation board meeting","agenda","consent calendar","quorum"],
    chips: [
      { label: "How items get approved?",     q: "How does the SAB vote on consent and action items at its meetings?" },
      { label: "When does SAB meet?",         q: "When does the State Allocation Board meet and how are meetings scheduled?" },
    ]},
  { match: ["appeal","form sab 189","189","district appeal"],
    chips: [
      { label: "Appeal timeline details?",    q: "What are the exact timelines for a school district appeal from filing to SAB meeting?" },
      { label: "Postpone an appeal?",         q: "How do I request postponement of a school district appeal before the SAB meeting?" },
    ]},
  { match: ["revise","new draft","create new draft","duplicate"],
    chips: [
      { label: "Revise a SAB 50-04?",         q: "How do I create a new draft to revise a submitted SAB 50-04 funding application?" },
      { label: "Revise an eligibility form?", q: "How do I revise a submitted SAB 50-03 eligibility form?" },
    ]},
  { match: ["upload","submit","document","attach","pdf"],
    chips: [
      { label: "File format requirements?",   q: "What file formats and size limits are accepted for document uploads in OPSC Online?" },
      { label: "What happens after submit?",  q: "What happens after I submit my application in OPSC Online? What status changes should I expect?" },
    ]},
];

function getFollowUps(userMsg, reply) {
  const hay = ((userMsg || "") + " " + (reply || "")).toLowerCase();
  for (const rule of FOLLOWUP_RULES) {
    if (rule.match.some(kw => hay.includes(kw.toLowerCase()))) {
      return rule.chips.slice(0, 3);
    }
  }
  return [
    { label: "What funding programs exist?",   q: "What SFP funding programs are available and which one is right for my project?" },
    { label: "How do I start an application?", q: "How do I start a new SFP funding application in OPSC Online?" },
    { label: "Explain key SFP terms",          q: "Explain the most important SFP terms and abbreviations for a new user." },
  ];
}

function renderMarkdown(text) {
  const lines = text.split("\n");
  const elements = [];
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    // Headings
    if (/^#{1,3}\s/.test(line)) {
      const level = line.match(/^(#+)/)[1].length;
      const headingText = line.replace(/^#{1,3}\s+/, "");
      elements.push(
        <div key={i} style={{
          color: level === 1 ? NAVY : BLUE,
          fontSize: level === 1 ? "15px" : "13.5px",
          fontWeight: 700,
          margin: "12px 0 5px",
          lineHeight: 1.4,
          borderBottom: `1px solid ${level === 1 ? "#C8D8EC" : "#D8E8F5"}`,
          paddingBottom: "3px",
        }} dangerouslySetInnerHTML={{ __html: boldify(headingText) }} />
      );
      i++;
    // Ordered list
    } else if (/^\d+\.\s/.test(line)) {
      const items = [];
      while (i < lines.length && /^\d+\.\s/.test(lines[i])) {
        const itemText = lines[i].replace(/^\d+\.\s/, "");
        // Check for sub-bullets on next lines
        const subItems = [];
        while (i + 1 < lines.length && /^\s{2,}[-•]\s/.test(lines[i + 1])) {
          i++;
          subItems.push(lines[i].replace(/^\s+[-•]\s/, ""));
        }
        items.push({ text: itemText, subs: subItems });
        i++;
      }
      elements.push(
        <ol key={`ol-${i}`} style={{ margin: "6px 0 6px 18px", padding: 0 }}>
          {items.map((it, j) => (
            <li key={j} style={{ marginBottom: it.subs.length ? 2 : 3 }}>
              <span dangerouslySetInnerHTML={{ __html: boldify(it.text) }} />
              {it.subs.length > 0 && (
                <ul style={{ margin: "3px 0 3px 14px", padding: 0 }}>
                  {it.subs.map((s, k) => (
                    <li key={k} style={{ marginBottom: 2 }} dangerouslySetInnerHTML={{ __html: boldify(s) }} />
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ol>
      );
    // Unordered list
    } else if (/^[-•]\s/.test(line)) {
      const items = [];
      while (i < lines.length && /^[-•]\s/.test(lines[i])) {
        const itemText = lines[i].replace(/^[-•]\s/, "");
        const subItems = [];
        while (i + 1 < lines.length && /^\s{2,}[-•]\s/.test(lines[i + 1])) {
          i++;
          subItems.push(lines[i].replace(/^\s+[-•]\s/, ""));
        }
        items.push({ text: itemText, subs: subItems });
        i++;
      }
      elements.push(
        <ul key={`ul-${i}`} style={{ margin: "6px 0 6px 18px", padding: 0 }}>
          {items.map((it, j) => (
            <li key={j} style={{ marginBottom: it.subs.length ? 2 : 3 }}>
              <span dangerouslySetInnerHTML={{ __html: boldify(it.text) }} />
              {it.subs.length > 0 && (
                <ul style={{ margin: "3px 0 3px 14px", padding: 0 }}>
                  {it.subs.map((s, k) => (
                    <li key={k} style={{ marginBottom: 2 }} dangerouslySetInnerHTML={{ __html: boldify(s) }} />
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      );
    // Horizontal rule / divider
    } else if (line.trim() === "---") {
      elements.push(<hr key={i} style={{ border: "none", borderTop: "1px solid #E0E8F2", margin: "8px 0" }} />);
      i++;
    // Blank line
    } else if (line.trim() === "") {
      i++;
    // Table row
    } else if (/^\|.+\|$/.test(line)) {
      const tableLines = [];
      while (i < lines.length && /^\|.+\|$/.test(lines[i])) {
        tableLines.push(lines[i]);
        i++;
      }
      // Filter out separator rows like |---|---|
      const rows = tableLines.filter(r => !/^\|[-:\s|]+\|$/.test(r));
      if (rows.length > 0) {
        const header = rows[0].split("|").filter((_, ci) => ci > 0 && ci < rows[0].split("|").length - 1);
        const body = rows.slice(1);
        elements.push(
          <div key={`tbl-${i}`} style={{ overflowX: "auto", margin: "8px 0" }}>
            <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 12 }}>
              <thead>
                <tr style={{ background: "#EDF3FA" }}>
                  {header.map((h, hi) => (
                    <th key={hi} style={{ padding: "5px 9px", textAlign: "left", border: "1px solid #D0DEF0", fontWeight: 600, color: NAVY }}
                      dangerouslySetInnerHTML={{ __html: boldify(h.trim()) }} />
                  ))}
                </tr>
              </thead>
              <tbody>
                {body.map((r, ri) => {
                  const cells = r.split("|").filter((_, ci) => ci > 0 && ci < r.split("|").length - 1);
                  return (
                    <tr key={ri} style={{ background: ri % 2 === 0 ? "#fff" : "#F7FAFD" }}>
                      {cells.map((c, ci) => (
                        <td key={ci} style={{ padding: "4px 9px", border: "1px solid #D0DEF0", color: "#2A3550" }}
                          dangerouslySetInnerHTML={{ __html: boldify(c.trim()) }} />
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      }
    // Blockquote / note
    } else if (/^>\s/.test(line)) {
      const noteLines = [];
      while (i < lines.length && /^>\s/.test(lines[i])) {
        noteLines.push(lines[i].replace(/^>\s/, ""));
        i++;
      }
      elements.push(
        <div key={`bq-${i}`} style={{
          borderLeft: `3px solid ${GOLD}`, background: "#FDF8ED",
          padding: "6px 10px", margin: "6px 0", borderRadius: "0 6px 6px 0", fontSize: 12,
        }}>
          {noteLines.map((nl, nli) => (
            <p key={nli} style={{ margin: "0 0 2px" }} dangerouslySetInnerHTML={{ __html: boldify(nl) }} />
          ))}
        </div>
      );
    // Sub-header: entire line is bold (e.g. **A few things to confirm:**)
    } else if (/^\*\*[^*]+\*\*:?$/.test(line.trim())) {
      const subText = line.trim().replace(/^\*\*/, "").replace(/\*\*:?$/, "");
      elements.push(
        <p key={i} style={{
          margin: "10px 0 4px", lineHeight: 1.4,
          color: BLUE, fontSize: "14px", fontWeight: 600,
        }}>{subText}</p>
      );
      i++;
    // Paragraph
    } else {
      elements.push(
        <p key={i} style={{ margin: "0 0 6px", lineHeight: 1.56 }} dangerouslySetInnerHTML={{ __html: boldify(line) }} />
      );
      i++;
    }
  }
  return elements;
}

// ── Copy Button ─────────────────────────────────────────────────────────────
// ── Copy Button ─────────────────────────────────────────────────────────────
function CopyButton({ text }) {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    // Strip markdown syntax for a clean plain-text copy
    const plain = text
      .replace(/\*\*(.+?)\*\*/g, "$1")
      .replace(/\*(.+?)\*/g, "$1")
      .replace(/^#{1,3}\s+/gm, "")
      .replace(/^[-•]\s/gm, "• ")
      .replace(/^\d+\.\s/gm, (m) => m)
      .trim();

    const done = () => { setCopied(true); setTimeout(() => setCopied(false), 2000); };

    // Primary: Clipboard API (works in HTTPS / modern browsers)
    if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
      navigator.clipboard.writeText(plain).then(done).catch(() => fallback(plain, done));
    } else {
      fallback(plain, done);
    }
  };

  const fallback = (plain, done) => {
    // Universal fallback: create a hidden textarea, select, and execCommand
    try {
      const ta = document.createElement("textarea");
      ta.value = plain;
      ta.setAttribute("readonly", "");
      ta.style.cssText = "position:fixed;top:-9999px;left:-9999px;opacity:0;";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      done();
    } catch (_) { /* silent fail */ }
  };

  return (
    <button onClick={copy} title="Copy response text" style={{
      background: "none", border: "none", cursor: "pointer",
      color: copied ? GREEN : "#8C96A6", fontSize: 11, display: "flex",
      alignItems: "center", gap: 3, padding: "2px 4px",
      borderRadius: 4, transition: "color .15s",
    }}>
      {copied ? (
        <svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor">
          <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
        </svg>
      )}
      {copied ? "Copied!" : "Copy"}
    </button>
  );
}

// ── Feedback Buttons ─────────────────────────────────────────────────────────
// Ratings are stored locally for this session (Phase 1).
// In Phase 2 these will be sent to the OPSC analytics back-end.
function FeedbackButtons({ msgId, feedback, setFeedback }) {
  const val = feedback[msgId];
  const [confirmed, setConfirmed] = useState(false);

  const vote = (v) => {
    const next = val === v ? null : v;          // toggle off if same button clicked
    setFeedback(prev => ({ ...prev, [msgId]: next }));
    if (next) {
      setConfirmed(true);
      setTimeout(() => setConfirmed(false), 2200);
    }
  };

  const btn = (type, icon, label) => (
    <button
      onClick={() => vote(type)}
      title={`${label} — rating stored for this session`}
      style={{
        background: val === type ? (type === "up" ? "#E6F4EC" : "#FDEAEA") : "none",
        border: val === type
          ? `1px solid ${type === "up" ? "#A3D4B0" : "#F09595"}`
          : "1px solid transparent",
        cursor: "pointer",
        color: val === type ? (type === "up" ? GREEN : "#A32D2D") : "#8C96A6",
        borderRadius: 4, padding: "2px 5px", fontSize: 12,
        transition: "all .15s",
      }}
    >{icon}</button>
  );

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      {btn("up",   "👍", "Helpful")}
      {btn("down", "👎", "Not helpful")}
      {confirmed && (
        <span style={{
          fontSize: 10, color: val === "up" ? GREEN : "#8C5000",
          animation: "opscFade .2s ease",
        }}>
          {val === "up" ? "Thanks for the feedback!" : "We'll work to improve."}
        </span>
      )}
    </div>
  );
}


// ── Wizard Modal ─────────────────────────────────────────────────────────────
function WizardModal({ onClose, onSend }) {
  const [nodeId, setNodeId] = useState("start");
  const [history, setHistory] = useState([]);           // stack of previous nodeIds
  const [result, setResult] = useState(null);

  const node = WIZARD_TREE.nodes[nodeId];
  const totalPossibleSteps = 4;
  const stepNum = history.length + 1;

  const choose = (choice) => {
    if (choice.result) {
      setResult(WIZARD_TREE.results[choice.result]);
    } else if (choice.next) {
      setHistory(h => [...h, nodeId]);
      setNodeId(choice.next);
    }
  };

  const goBack = () => {
    if (result) { setResult(null); return; }
    if (history.length === 0) { onClose(); return; }
    const prev = history[history.length - 1];
    setHistory(h => h.slice(0, -1));
    setNodeId(prev);
  };

  const launch = () => {
    if (result) { onSend(result.action); onClose(); }
  };

  return (
    <div style={{
      position: "absolute", inset: 0, zIndex: 200,
      background: "rgba(15,30,60,.55)", backdropFilter: "blur(2px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      animation: "opscFade .18s ease",
      borderRadius: "inherit",
    }}>
      <div style={{
        background: "#fff", borderRadius: 14,
        width: "calc(100% - 28px)", maxWidth: 460,
        boxShadow: "0 8px 32px rgba(10,25,60,.22)",
        overflow: "hidden", display: "flex", flexDirection: "column",
      }}>
        {/* Wizard header */}
        <div style={{
          background: "#1A3B6F", color: "#fff",
          padding: "11px 16px", display: "flex", alignItems: "center", gap: 10,
        }}>
          <span style={{ fontSize: 16 }}>🧭</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 13 }}>Find My Program Wizard</div>
            {!result && (
              <div style={{ fontSize: 10.5, opacity: .72, marginTop: 1 }}>
                Step {stepNum} of {totalPossibleSteps} · {node?.hint || "Answer a few quick questions"}
              </div>
            )}
          </div>
          <button onClick={onClose} style={{
            background: "rgba(255,255,255,.15)", border: "none",
            color: "#fff", width: 24, height: 24, borderRadius: 6,
            cursor: "pointer", fontSize: 13, display: "flex",
            alignItems: "center", justifyContent: "center",
          }}>✕</button>
        </div>

        {/* Progress bar */}
        {!result && (
          <div style={{ height: 3, background: "#E0E6F0" }}>
            <div style={{
              height: "100%", background: "#C9901A",
              width: `${(history.length / totalPossibleSteps) * 100}%`,
              transition: "width .3s ease",
            }} />
          </div>
        )}

        {/* Body */}
        <div style={{ padding: "18px 16px 14px", overflowY: "auto", maxHeight: 380 }}>
          {result ? (
            /* Result card */
            <div style={{ animation: "opscSlideIn .2s ease" }}>
              <div style={{
                display: "flex", alignItems: "flex-start", gap: 12,
                background: "#F0F5FB", borderRadius: 10, padding: "12px 14px",
                border: `1.5px solid ${result.color}22`,
                marginBottom: 14,
              }}>
                <span style={{ fontSize: 26, lineHeight: 1, marginTop: 2 }}>{result.icon}</span>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13.5, color: result.color, marginBottom: 4 }}>
                    {result.title}
                  </div>
                  <div style={{ fontSize: 12.5, color: "#3A4966", lineHeight: 1.55 }}>
                    {result.summary}
                  </div>
                </div>
              </div>
              <div style={{ fontSize: 11.5, color: "#546079", marginBottom: 14, lineHeight: 1.5 }}>
                Click <strong>Open in Chat</strong> to ask the OPSC Assistant about this program in detail.
              </div>
              <button onClick={launch} style={{
                background: "#1A3B6F", color: "#fff", border: "none",
                borderRadius: 8, padding: "9px 18px", fontWeight: 600,
                fontSize: 13, cursor: "pointer", width: "100%",
                fontFamily: "inherit",
              }}>
                💬  Open in Chat
              </button>
            </div>
          ) : (
            /* Question + choices */
            <div style={{ animation: "opscSlideIn .15s ease" }}>
              <div style={{ fontWeight: 600, fontSize: 14, color: "#1A3B6F", marginBottom: 14, lineHeight: 1.4 }}>
                {node?.q}
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
                {node?.choices.map((ch, i) => (
                  <button key={i} onClick={() => choose(ch)} style={{
                    background: "#F3F6FB", border: "1px solid #D0D8EC",
                    borderRadius: 9, padding: "9px 13px",
                    textAlign: "left", cursor: "pointer",
                    fontSize: 12.5, color: "#1C2333", fontFamily: "inherit",
                    transition: "all .15s", lineHeight: 1.4,
                    display: "flex", alignItems: "center", gap: 10,
                  }}
                    onMouseEnter={e => { e.currentTarget.style.background = "#E6F0F7"; e.currentTarget.style.borderColor = "#0066aa"; }}
                    onMouseLeave={e => { e.currentTarget.style.background = "#F3F6FB"; e.currentTarget.style.borderColor = "#D0D8EC"; }}
                  >
                    <span style={{ flex: 1 }}>{ch.label}</span>
                    <span style={{ color: "#8C96A6", fontSize: 14 }}>›</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Footer nav */}
        <div style={{
          borderTop: "1px solid #EDF0F5", padding: "8px 16px",
          display: "flex", justifyContent: "space-between", alignItems: "center",
          background: "#FAFBFD",
        }}>
          <button onClick={goBack} style={{
            background: "none", border: "1px solid #D0D8EC",
            color: "#546079", fontSize: 12, padding: "4px 12px",
            borderRadius: 6, cursor: "pointer", fontFamily: "inherit",
          }}>
            {history.length === 0 && !result ? "✕ Close" : "‹ Back"}
          </button>
          <span style={{ fontSize: 10.5, color: "#8C96A6" }}>
            OPSC Online Assistant · Phase 1
          </span>
        </div>
      </div>
    </div>
  );
}

function boldify(t) {
  return t
    .replace(/\*\*(Important[^*]*)\*\*/g, '<strong style="color:#B45309">$1</strong>')
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(.+?)\*/g, "<em>$1</em>")
    .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer" style="color:#0066aa;text-decoration:underline;cursor:pointer;">$1</a>')
    .replace(/(^|[\s(])((https?:\/\/)[^\s<)"]+)/g,
      '$1<a href="$2" target="_blank" rel="noopener noreferrer" style="color:#0066aa;text-decoration:underline;cursor:pointer;">$2</a>');
}

function TypingDots() {
  return (
    <div style={{ display: "flex", gap: 8, alignSelf: "flex-start" }}>
      <div style={avatarStyle(NAVY)}>OPSC</div>
      <div style={{
        background: "#fff", border: "1px solid #D8DEE8",
        borderRadius: 12, borderTopLeftRadius: 4,
        padding: "9px 13px", display: "flex", gap: 4, alignItems: "center",
      }}>
        {[0, 1, 2].map(i => (
          <div key={i} style={{
            width: 6, height: 6, borderRadius: "50%", background: "#8C96A6",
            animation: "opscPulse 1.2s infinite",
            animationDelay: `${i * 0.2}s`,
          }} />
        ))}
      </div>
    </div>
  );
}

function avatarStyle(bg) {
  return {
    width: 28, height: 28, borderRadius: "50%",
    background: bg, color: "#fff",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 10, fontWeight: 600,
    flexShrink: 0, marginTop: 3,
  };
}

export default function OPSCChatbot() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const [lang, setLang] = useState("en");
  const [history, setHistory] = useState([]);
  const [started, setStarted] = useState(false);
  const [activeCategory, setActiveCategory] = useState("nav");
  const [feedback, setFeedback] = useState({});
  const [atBottom, setAtBottom] = useState(true);
  const [wizardOpen, setWizardOpen] = useState(false);
  const [lastUserMsg, setLastUserMsg] = useState("");
  const msgsRef = useRef(null);
  const textareaRef = useRef(null);

  useEffect(() => {
    if (atBottom && msgsRef.current) {
      msgsRef.current.scrollTop = msgsRef.current.scrollHeight;
    }
  }, [messages, busy, atBottom]);

  const handleScroll = () => {
    if (!msgsRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = msgsRef.current;
    setAtBottom(scrollHeight - scrollTop - clientHeight < 40);
  };

  const scrollToBottom = () => {
    if (msgsRef.current) {
      msgsRef.current.scrollTop = msgsRef.current.scrollHeight;
      setAtBottom(true);
    }
  };

  const clearConversation = () => {
    setMessages([]);
    setHistory([]);
    setStarted(false);
    setFeedback({});
    setInput("");
    setAtBottom(true);
    setLastUserMsg("");
    setWizardOpen(false);
  };

  const sendMessage = async (text) => {
    const msg = (text || input).trim();
    if (!msg || busy) return;
    setInput("");
    setBusy(true);
    setStarted(true);
    setLastUserMsg(msg);
    setWizardOpen(false);

    const userMsg = { role: "user", content: msg, id: Date.now() };
    setMessages(prev => [...prev, userMsg]);

    const newHistory = [...history, { role: "user", content: msg }];

    try {
		  const res = await fetch("/api/chat", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
		
        body: JSON.stringify({
          model: "claude-sonnet-4-6",
          max_tokens: 1000,
          system: SYSTEM_PROMPT,
          messages: newHistory,
        }),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error?.message || `HTTP ${res.status}`);
      }

      const data = await res.json();
      const reply = data?.content?.[0]?.text;

      if (reply) {
        const updatedHistory = [...newHistory, { role: "assistant", content: reply }];
        const trimmed = updatedHistory.length > 24 ? updatedHistory.slice(-24) : updatedHistory;
        setHistory(trimmed);
        setMessages(prev => [...prev, { role: "assistant", content: reply, id: Date.now() + 1 }]);
      } else {
        throw new Error("Empty response received.");
      }
    } catch (err) {
      setMessages(prev => [...prev, {
        role: "error",
        content: err.message || "Unexpected error. Please try again.",
        id: Date.now() + 2,
      }]);
    }
    setBusy(false);
  };

  const handleKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  };

  const autoResize = (e) => {
    const el = e.target;
    el.style.height = "auto";
    el.style.height = Math.min(el.scrollHeight, 80) + "px";
  };

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", fontSize: 13, color: "#1C2333", position: "relative" }}>
      {/* Decision Tree Wizard overlay */}
      {wizardOpen && (
        <WizardModal onClose={() => setWizardOpen(false)} onSend={sendMessage} />
      )}
      <style>{`
        @keyframes opscPulse { 0%,60%,100%{opacity:.3;transform:scale(.8)} 30%{opacity:1;transform:scale(1)} }
        @keyframes opscFade { from{opacity:0;transform:translateY(5px)} to{opacity:1;transform:translateY(0)} }
        @keyframes opscSlideIn { from{opacity:0;transform:translateY(-4px)} to{opacity:1;transform:translateY(0)} }
        @keyframes opscBounce { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-3px)} }
        .opsc-msg { animation: opscFade .2s ease; }
        .opsc-topic:hover { background: ${BLUE_LT} !important; border-color: ${BLUE} !important; color: ${NAVY} !important; }
        .opsc-wchip:hover { background: rgba(255,255,255,.3) !important; }
        .opsc-send:hover { background: ${NAVY_DK} !important; }
        .opsc-qa:hover { background: ${BLUE_LT} !important; border-color: ${BLUE} !important; }
        .opsc-lang:hover { background: ${BLUE_LT} !important; }
        .opsc-sbtn:hover { background: #e4ecf6 !important; }
        .opsc-catbtn:hover { background: ${BLUE_LT} !important; border-color: ${BLUE} !important; color: ${NAVY} !important; }
        .opsc-clearbtn:hover { background: #F5E8E8 !important; color: #7A2020 !important; }
        .opsc-wizard-btn:hover { background: #A87214 !important; }
        .opsc-topicchip:hover { background: ${BLUE_LT} !important; border-color: ${BLUE} !important; color: ${NAVY} !important; }
        .opsc-scrollbtn:hover { background: ${NAVY_DK} !important; }
        .opsc-retrybtn:hover { background: ${BLUE_LT} !important; border-color: ${BLUE} !important; }
        .opsc-msgactions { opacity: 0; transition: opacity .15s; }
        .opsc-msgwrap:hover .opsc-msgactions { opacity: 1; }
        textarea:focus { border-color: ${BLUE} !important; background: #fff !important; outline: none !important; }
        ::-webkit-scrollbar { width: 5px; height: 5px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: #C8D0DC; border-radius: 8px; }
        ::-webkit-scrollbar-thumb:hover { background: #8C96A6; }
      `}</style>

      {/* Header — matches OPSC Online login page structure */}
      <div style={{ flexShrink: 0, borderRadius: "12px 12px 0 0", overflow: "hidden" }}>
        {/* Solid navy blue top banner */}
        <div style={{
          background: NAVY,
          height: 12,
          width: "100%",
        }} />
        {/* White logo + controls row */}
        <div style={{
          background: "#fff", padding: "7px 16px",
          display: "flex", alignItems: "center", gap: 12,
          borderBottom: `3px solid ${GOLD}`,
        }}>
          <img
            src={OPSC_LOGO}
            alt="OPSC – Office of Public School Construction, Department of General Services"
            style={{ height: 38, width: "auto", flexShrink: 0 }}
          />
          <div style={{ flex: 1 }} />
          <div style={{
            background: NAVY, color: "#fff", fontSize: 9.5, fontWeight: 600,
            padding: "2px 8px", borderRadius: 4, letterSpacing: ".5px",
          }}>PHASE 1</div>
          {/* Wizard trigger — always visible */}
          <button className="opsc-wizard-btn" onClick={() => setWizardOpen(true)} title="Find My Program Wizard" style={{
            background: GOLD, color: "#fff", border: "none",
            fontSize: 11, fontWeight: 600, padding: "3px 9px",
            borderRadius: 4, cursor: "pointer", fontFamily: "inherit",
            display: "flex", alignItems: "center", gap: 4,
            transition: "all .15s",
          }}>
            🧭 Find My Program
          </button>
          {started && (
            <button className="opsc-clearbtn" onClick={clearConversation} title="Clear conversation" style={{
              background: "none", border: "1px solid #E0E0E0",
              color: "#8C96A6", fontSize: 11, fontWeight: 500,
              padding: "2px 8px", borderRadius: 4,
              cursor: "pointer", fontFamily: "inherit",
              display: "flex", alignItems: "center", gap: 4,
              transition: "all .15s",
            }}>
              <svg viewBox="0 0 24 24" width="11" height="11" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
              New Chat
            </button>
          )}
          <div style={{ display: "flex", gap: 3 }}>
            {["en", "es", "zh"].map(l => (
              <button key={l} className="opsc-lang" onClick={() => setLang(l)} style={{
                background: lang === l ? NAVY : "#F3F5F8",
                border: `0.5px solid ${lang === l ? NAVY : "#C8D0DC"}`,
                color: lang === l ? "#fff" : "#546079",
                padding: "2px 9px", borderRadius: 4,
                fontSize: 10.5, fontWeight: 500, cursor: "pointer",
                fontFamily: "inherit",
              }}>
                {l === "zh" ? "中文" : l.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Topic Browser — Category tabs + topic chips */}
      <div style={{ background: "#fff", borderBottom: "1px solid #E0E6F0", flexShrink: 0 }}>
        {/* Category tab row */}
        <div style={{
          padding: "6px 10px 5px", display: "flex", gap: 4,
          overflowX: "auto", borderBottom: "1px solid #EDF0F5",
        }}>
          {TOPIC_CATEGORIES.map(cat => {
            const isActive = activeCategory === cat.id;
            return (
              <button key={cat.id} className="opsc-catbtn"
                onClick={() => setActiveCategory(cat.id)}
                style={{
                  background: isActive ? NAVY : "#F3F5F8",
                  border: `1px solid ${isActive ? NAVY : "#D8DEE8"}`,
                  color: isActive ? "#fff" : "#546079",
                  padding: "3px 9px",
                  borderRadius: 10, fontSize: 10.5, cursor: "pointer",
                  whiteSpace: "nowrap", fontFamily: "inherit",
                  fontWeight: isActive ? 600 : 400,
                  transition: "all .15s",
                  display: "flex", alignItems: "center", gap: 4,
                }}>
                <span style={{ fontSize: 11 }}>{cat.icon}</span>
                {cat.label}
              </button>
            );
          })}
        </div>
        {/* Topic chips for active category */}
        <div style={{
          padding: "5px 10px 6px", display: "flex", gap: 4,
          flexWrap: "wrap", animation: "opscSlideIn .15s ease",
        }}>
          {(TOPIC_CATEGORIES.find(c => c.id === activeCategory)?.topics || []).map(t => (
            <button key={t.label} className="opsc-topicchip" onClick={() => sendMessage(t.q)} style={{
              background: "#F3F5F8", border: "1px solid #D0D8E8",
              color: "#3A4966", padding: "3px 10px",
              borderRadius: 10, fontSize: 11, cursor: "pointer",
              fontFamily: "inherit", transition: "all .15s",
            }}>{t.label}</button>
          ))}
        </div>
      </div>

      {/* Messages */}
      <div ref={msgsRef} onScroll={handleScroll} style={{
        height: 420, overflowY: "auto",
        padding: "14px 16px", display: "flex", flexDirection: "column",
        gap: 12, background: "#F3F5F8", position: "relative",
      }}>

        {/* Welcome */}
        {!started && (
          <div className="opsc-msg" style={{ display: "flex", gap: 8, alignSelf: "flex-start", maxWidth: "90%" }}>
            <div style={avatarStyle(NAVY)}>OPSC</div>
            <div>
              <div style={{
                background: NAVY, borderRadius: 12, borderTopLeftRadius: 4,
                padding: "14px 16px", color: "#fff",
              }}>
                <div style={{ fontSize: 13.5, fontWeight: 600, marginBottom: 4 }}>
                  Welcome to the OPSC Online Assistant
                </div>
                <div style={{ fontSize: 12, opacity: .82, lineHeight: 1.5 }}>
                  I provide step-by-step guidance for School Facility Program (SFP) applications,
                  eligibility forms, funding workflows, and OPSC Online navigation.
                  Select a topic above or ask me anything below.
                </div>
                {/* Wizard CTA */}
                <button onClick={() => setWizardOpen(true)} style={{
                  display: "flex", alignItems: "center", gap: 7,
                  background: GOLD, color: "#fff", border: "none",
                  borderRadius: 8, padding: "8px 14px", marginTop: 12,
                  fontWeight: 600, fontSize: 12.5, cursor: "pointer",
                  fontFamily: "inherit", width: "100%", justifyContent: "center",
                }}>
                  🧭  Not sure where to start? Use the Find My Program Wizard
                </button>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginTop: 10 }}>
                  {QUICK_STARTS.map(q => (
                    <button key={q} className="opsc-wchip" onClick={() => sendMessage(q)} style={{
                      background: "rgba(255,255,255,.18)",
                      border: "0.5px solid rgba(255,255,255,.3)",
                      color: "#fff", padding: "3px 10px",
                      borderRadius: 11, fontSize: 11,
                      cursor: "pointer", fontFamily: "inherit",
                    }}>{q}</button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {messages.map(m => {
          if (m.role === "user") return (
            <div key={m.id} className="opsc-msg" style={{ display: "flex", gap: 8, alignSelf: "flex-end", flexDirection: "row-reverse", maxWidth: "86%" }}>
              <div style={avatarStyle(BLUE)}>You</div>
              <div style={{
                background: NAVY, color: "#fff",
                padding: "9px 13px", borderRadius: 12, borderTopRightRadius: 4,
                fontSize: 13, lineHeight: 1.55,
              }}>{m.content}</div>
            </div>
          );
          if (m.role === "error") return (
            <div key={m.id} className="opsc-msg" style={{ display: "flex", gap: 8, alignSelf: "flex-start", maxWidth: "86%" }}>
              <div style={avatarStyle("#A32D2D")}>!</div>
              <div>
                <div style={{
                  background: "#FDEAEA", border: "1px solid #F09595",
                  borderRadius: 12, borderTopLeftRadius: 4,
                  padding: "9px 13px", fontSize: 12.5, color: "#791F1F",
                }}>
                  <strong>Error:</strong> {m.content}
                </div>
                <div style={{ marginTop: 4, paddingLeft: 2 }}>
                  <button className="opsc-retrybtn" onClick={() => {
                    const lastUser = [...messages].reverse().find(x => x.role === "user");
                    if (lastUser) sendMessage(lastUser.content);
                  }} style={{
                    background: "#fff", border: "1px solid #C8D0DC",
                    color: "#546079", fontSize: 11, padding: "2px 10px",
                    borderRadius: 6, cursor: "pointer", fontFamily: "inherit",
                    transition: "all .15s",
                  }}>↺ Retry</button>
                </div>
              </div>
            </div>
          );
          const isLastMsg = m.id === messages[messages.length - 1]?.id;
          return (
            <div key={m.id} className="opsc-msg opsc-msgwrap" style={{ display: "flex", gap: 8, alignSelf: "flex-start", maxWidth: "90%" }}>
              <div style={avatarStyle(NAVY)}>OPSC</div>
              <div style={{ minWidth: 0 }}>
                <div style={{
                  background: "#fff", border: "1px solid #D8DEE8",
                  borderRadius: 12, borderTopLeftRadius: 4,
                  padding: "9px 13px", fontSize: 13, lineHeight: 1.56, color: "#1C2333",
                }}>
                  {renderMarkdown(m.content)}
                </div>
                {/* Message actions — visible on hover */}
                <div className="opsc-msgactions" style={{
                  display: "flex", alignItems: "center", gap: 6,
                  marginTop: 4, paddingLeft: 4,
                }}>
                  <CopyButton text={m.content} />
                  <div style={{ width: 1, height: 12, background: "#D8DEE8" }} />
                  <FeedbackButtons msgId={m.id} feedback={feedback} setFeedback={setFeedback} />
                </div>
                {/* Follow-up chips — only on the last assistant message */}
                {isLastMsg && !busy && (() => {
                  const chips = getFollowUps(lastUserMsg, m.content);
                  return chips.length > 0 ? (
                    <div style={{
                      marginTop: 8, display: "flex", flexWrap: "wrap", gap: 5,
                      animation: "opscSlideIn .25s ease",
                    }}>
                      <span style={{ fontSize: 10, color: "#8C96A6", alignSelf: "center", marginRight: 2 }}>
                        💡 Follow-up:
                      </span>
                      {chips.map(c => (
                        <button key={c.label} onClick={() => sendMessage(c.q)} style={{
                          background: "#EDF3FA", border: "1px solid #C0D4EC",
                          color: "#1A3B6F", padding: "3px 10px", borderRadius: 10,
                          fontSize: 11, cursor: "pointer", fontFamily: "inherit",
                          transition: "all .15s",
                        }}
                          onMouseEnter={e => { e.currentTarget.style.background = BLUE_LT; e.currentTarget.style.borderColor = BLUE; }}
                          onMouseLeave={e => { e.currentTarget.style.background = "#EDF3FA"; e.currentTarget.style.borderColor = "#C0D4EC"; }}
                        >{c.label}</button>
                      ))}
                    </div>
                  ) : null;
                })()}
              </div>
            </div>
          );
        })}

        {busy && <TypingDots />}
      </div>

      {/* Scroll to bottom button */}
      {!atBottom && (
        <div style={{ position: "relative", height: 0 }}>
          <button className="opsc-scrollbtn" onClick={scrollToBottom} style={{
            position: "absolute", bottom: 8, right: 16, zIndex: 10,
            background: NAVY, color: "#fff", border: "none",
            width: 30, height: 30, borderRadius: "50%",
            cursor: "pointer", boxShadow: "0 2px 8px rgba(26,59,111,.35)",
            display: "flex", alignItems: "center", justifyContent: "center",
            animation: "opscBounce 1s ease infinite",
            transition: "background .15s",
          }}>
            <svg viewBox="0 0 24 24" width="14" height="14" fill="#fff">
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
            </svg>
          </button>
        </div>
      )}

      {/* Input */}
      <div style={{
        background: "#fff", borderTop: "1px solid #E0E6F0",
        padding: "10px 12px", display: "flex", gap: 8, alignItems: "flex-end",
        borderRadius: "0 0 12px 12px",
      }}>
        <div style={{ flex: 1, position: "relative" }}>
          <textarea
            ref={textareaRef}
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={handleKey}
            onInput={autoResize}
            placeholder={LANGS[lang]}
            rows={1}
            maxLength={2000}
            style={{
              width: "100%", boxSizing: "border-box",
              border: "1px solid #C8D0DC",
              borderRadius: 8, padding: "7px 11px",
              fontSize: 12.5, fontFamily: "inherit",
              resize: "none", minHeight: 32, maxHeight: 80,
              color: "#1C2333", background: "#F3F5F8",
              lineHeight: 1.5,
            }}
          />
          {input.length > 1600 && (
            <div style={{
              position: "absolute", bottom: 4, right: 8,
              fontSize: 10, color: input.length > 1900 ? "#A32D2D" : "#8C96A6",
            }}>{input.length}/2000</div>
          )}
        </div>
        <button
          className="opsc-send"
          onClick={() => sendMessage()}
          disabled={busy}
          style={{
            width: 32, height: 32, borderRadius: 8,
            background: busy ? "#8BAFD4" : NAVY,
            border: "none", cursor: busy ? "not-allowed" : "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
            flexShrink: 0, transition: "background .15s",
          }}
        >
          <svg viewBox="0 0 24 24" width="14" height="14" fill="#fff">
            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
          </svg>
        </button>
      </div>

      {/* Disclaimer */}
      <div style={{
        textAlign: "center", fontSize: 10, color: "#8C96A6",
        padding: "5px 12px", lineHeight: 1.4,
        background: "#fff", borderTop: "1px solid #EDF0F5",
        borderRadius: "0 0 12px 12px",
      }}>
        OPSC Online Assistant · AI-powered guidance only · Verify final decisions with OPSC staff ·{" "}
        <a href="https://www.dgs.ca.gov/opsc/" style={{ color: BLUE }}>dgs.ca.gov/opsc</a>
      </div>
    </div>
  );
}
